import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import * as XLSX from "xlsx";
import * as moment from "moment";
import { GLOBAL } from "src/app/app.globals";
import { CommonApiService } from "src/app/common/common-api.service";
import { LaboursService } from "../labours/labours.service";
import { TradeMasterParams } from "src/app/common/common-api.model";
import { forkJoin, Observable } from 'rxjs';
import * as _ from "lodash";
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { LogHelperService } from "src/app/core/services/log-helper.service";
import { DataShareService } from "src/app/service/data-share.service";
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

declare const $: any;

@Component({
  selector: 'app-import-excel',
  templateUrl: './import-excel.component.html',
  styleUrls: ['./import-excel.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImportExcelComponent implements OnInit {
  @ViewChild("fileInput") fileInput;
  @Output() public save: EventEmitter<void>;
  @Output() public closeModal: EventEmitter<any>;

  totalExcelData: number = 0;
  validCount: number = 0;
  invalidCount: number = 0;

  isLoading: boolean = false;
  dataUpload: boolean = false;
  dataSet: boolean = false;
  isUploadFile = false;

  tableForm: FormGroup;
  tradeMasterParams: TradeMasterParams;

  columnDefs: any[] = [];
  groupHeaders: any[] = [];
  tableData: any[] = [];
  globalSettingData: any[] = [];
  globalDataSampleDownload: any[] = [];
  driverTradeCodeArr: any[] = [];
  labourData: any[] = [];
  pincodeList: any[] = [];
  genderList: any[] = [];
  maritalStatusList: any[] = [];
  qualificationList: any[] = [];
  qulificationStreamList: any[] = [];
  technicalQulificationList: any[] = [];
  bloodGroupList: any[] = [];
  skillList: any[] = [];
  tradeList: any[] = [];
  relationList: any[] = [];
  bankNameList: any[] = [];
  workSiteList: any[] = [];
  permanentVillageList: any[] = [];
  localVillageList: any[] = [];
  emergencyVillageList: any[] = [];
  referenceVillageList: any[] = [];
  drivingLicenseType: any[] = [];
  workSiteCategoryList: any[] = [];
  castList: any[] = [];
  religionList: any[] = [];
  plantUnitDepartmentTree: any[] = [];
  validityPeriodList: any[] = [];
  workmanCategoryList: any[] = [];
  identityList: any[] = [];
  nationalityList: any[] = [];
  labourForList: any[] = [];
  wageCriteriaList: any[] = [
    {
      id: "Wage / Salary   ≥   21000.00/-   ( EC Policy Applicable)",
      text: "Wage / Salary   ≥   21000.00/-   ( EC Policy Applicable)",
    },
    {
      id: "Wage / Salary   <   21000.00/- (ESIC Applicable)",
      text: "Wage / Salary   <   21000.00/- (ESIC Applicable)",
    },
  ];

  fieldWithDropdown = ['Department_Code', 'SectionPlantRelationId1', 'SectionPlantRelationId2', 'SectionPlantRelationId3', 'Qualification'];

  fileError = ""
  policeVerificationRequiredCode: any = {};
  referenceContactDetailsRequiredCode: any = {};
  emergencyContactDetailsRequiredCode: any = {};
  bankAccountDetailsRequiredCode: any = {};
  aadharCardOrPassportRequiredCode: any = {};
  drivingLicenseRequiredCode: any = {};
  driverTradeCode: any = {};
  shortCodeWiseObjectMapping: any = {};
  pincodeMap = {};

  pincodeNotFoundSet = new Set();
private inputTimers: { [key: string]: any } = {};
  bankPaymentTypes: any;

  constructor(
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    public activeModal: NgbActiveModal,
    private labourService: LaboursService,
    private commonApiService: CommonApiService,
    private dataShareService: DataShareService,
    private logHelperService: LogHelperService,
  ) {
    this.closeModal = new EventEmitter();
    this.save = new EventEmitter();
    this.tradeMasterParams = {
      UserId: GLOBAL.USER_ID ? parseInt(GLOBAL.USER_ID) : 0,
    };
    this.plantUnitDepartmentTree = GLOBAL.PLANTUNITTREE
  }

  ngOnInit() {
    if (GLOBAL.GLOBALCODES.length === 0) {
      this.getGlobalSettings();
    } else {
      this.processGlobalSettings(GLOBAL.GLOBALCODES);
    }

    this.getShortCodeWiseMasterList();
    this.loadTradeList();
    this.getConractor();
    this.loadSkillList();

    this.tableForm = this.fb.group({
      rows: this.fb.array(this.labourData.map(row => this.createRowForm(row)))
    });
  }

  getGlobalSettings() {
    this.labourService.globalSettingCode("").subscribe(
      (res: any) => this.processGlobalSettings(res.Data.Table),
    );
  }

  processGlobalSettings(globalCodes) {
    this.checkPoliceVerificationRequired(globalCodes);
    this.checkContactReferenceDetailsRequired(globalCodes);
    this.checkEmergencyContactDetailsRequired(globalCodes);
    this.checkBankAccountDetailsRequired(globalCodes);
    this.checkAadharCardOrPassportRequired(globalCodes);
    this.checkDrivingLicenseRequired(globalCodes);

    this.globalSettingData = globalCodes.filter(i => i.Code === "MOD119PG196EXCLIMPPRO_Con");
    this.globalDataSampleDownload = globalCodes.filter(i => i.Code === "MOD101IMPEXCL");
  }

  checkPoliceVerificationRequired(table): void {
    this.policeVerificationRequiredCode = table.find(item => item.Code === 'MOD152PG195PROBGC');
    if (!this.policeVerificationRequiredCode) {
      this.policeVerificationRequiredCode = {};
    }
  }

  checkContactReferenceDetailsRequired(table): void {
    this.referenceContactDetailsRequiredCode = table.find(item => item.Code === 'MOD152PG198PROREFC');
    if (!this.referenceContactDetailsRequiredCode) {
      this.referenceContactDetailsRequiredCode = {};
    }
  }

  checkEmergencyContactDetailsRequired(table): void {
    this.emergencyContactDetailsRequiredCode = table.find(item => item.Code === 'MOD152PG197PROEMG');
    if (!this.emergencyContactDetailsRequiredCode) {
      this.emergencyContactDetailsRequiredCode = {};
    }
  }

  checkBankAccountDetailsRequired(table): void {
    this.bankAccountDetailsRequiredCode = table.find(item => item.Code === 'MOD152PG195PROBANMND');
    if (!this.bankAccountDetailsRequiredCode) {
      this.bankAccountDetailsRequiredCode = {};
    }
  }

  checkAadharCardOrPassportRequired(table): void {
    this.aadharCardOrPassportRequiredCode = table.find(item => item.Code === 'MOD152PG195PROFAADMND');
    if (!this.aadharCardOrPassportRequiredCode) {
      this.aadharCardOrPassportRequiredCode = {};
    }
  }

  checkDrivingLicenseRequired(table): void {
    this.drivingLicenseRequiredCode = table.find(item => item.Code === 'MOD152PG195DRVLIC');
    this.driverTradeCode = table.find(item => item.Code === 'MOD152PG195DRVLICTRADE');
    if (Object.keys(this.driverTradeCode).length) {
      this.driverTradeCodeArr = this.driverTradeCode.Value.split(",");
    }
    if (!this.drivingLicenseRequiredCode) {
      this.aadharCardOrPassportRequiredCode = {};
    }
    if (!this.driverTradeCode) {
      this.driverTradeCode = {};
    }
  }

  getShortCodeWiseMasterList() {
    forkJoin([this.labourService.getMasterListData_V2("GM294,GM198,GM331,GM575,GM612,GM618,GM858,GM875"), this.labourService.getMasterListData_V2("GM557,GM362,GM585,GM302,GM883,GM479,GM145,GM194"),this.labourService.getMasterListData_V2("GM303,GM342,GM352")]).subscribe((res) => {
      this.shortCodeWiseObjectMapping = { ...this.transformData(res[0]), ...this.transformData(res[1]), ...this.transformData(res[2]) };
    });
  }

  transformData(arr) {
    return arr.reduce((acc, item) => {
      acc[item.Parent_Code] = item.Values;
      return acc;
    }, {});
  }

  fillBankDetailDropdown(): Record<string, string>[] {
    this.bankNameList = this.shortCodeWiseObjectMapping['145'].map(({ MasterItem_Code, Name }) =>
      ({ id: MasterItem_Code, text: Name }));
    return this.bankNameList
  }


  fillDrivingLicenseTypeDropdown() {
    this.drivingLicenseType = this.shortCodeWiseObjectMapping['194'].map(({ MasterItem_Code, Name }) =>
      ({ id: MasterItem_Code, text: Name }));
    this.drivingLicenseType.unshift({ id: "", text: "-- Select Dropdown --" });
    return this.drivingLicenseType
  }

  fillPaymentTypeDropdown() {
    this.bankPaymentTypes = this.shortCodeWiseObjectMapping['303'].map(({ MasterItem_Code, Name }) =>
      ({ id: MasterItem_Code, text: Name }));
    this.bankPaymentTypes.unshift({ id: "", text: "-- Select Dropdown --" });
    return this.bankPaymentTypes  
  }


  fillMaritalStatusDropdown() {
    this.maritalStatusList = (this.shortCodeWiseObjectMapping['294']).map(item => ({
      id: item.MasterItem_Code,
      text: item.Name
    }));
    this.maritalStatusList.unshift({ id: "", text: "-- Select Dropdown --" });
    return this.maritalStatusList
  }

  fillRelationDropdown() {
    this.relationList = (this.shortCodeWiseObjectMapping['198']).map((item) => ({
      id: item.MasterItem_Code,
      text: item.Name,
    }));
    this.relationList.unshift({ id: "", text: "-- Select Dropdown --" });
    return this.relationList;
  }

  populateQualificationList() {
    this.qualificationList = this.shortCodeWiseObjectMapping['331'].map((item) => ({
      id: item.MasterItem_Code,
      text: item.Name,
      ShortCode: item.ShortCode,
    }));
    this.qualificationList.unshift({ id: "", text: "-- Select Dropdown --" });
    return this.qualificationList;
  }

  // fillQulificationStreamDropdown() {
  //   this.qulificationStreamList = (this.shortCodeWiseObjectMapping['352'] || []).map((item) => ({
  //     id: item.MasterItem_Code,
  //     text: item.Name,
  //     ShortCode: item.ShortCode,
  //   }));
  //   this.qulificationStreamList.unshift({ id: "", text: "-- Select Dropdown --" });
  //   return this.qulificationStreamList;
  // }

  // fillTechnicalQulificationDropdown() {
  //   this.technicalQulificationList = (this.shortCodeWiseObjectMapping['342'] || []).map((item) => ({
  //     id: item.MasterItem_Code,
  //     text: item.Name,
  //     ShortCode: item.ShortCode,
  //   }));
  //   this.technicalQulificationList.unshift({ id: "", text: "-- Select Dropdown --" });
  //   return this.technicalQulificationList;
  // }
  fillIdentityDropdown() {
    this.identityList = this.shortCodeWiseObjectMapping['575'].map((item) => ({
      id: item.MasterItem_Code,
      text: item.Name,
    }));
    this.identityList.unshift({ id: "", text: "-- Select Dropdown --" });
    return this.identityList
  }

  fillWorkSiteDropdown() {
    this.workSiteList = this.shortCodeWiseObjectMapping['612'].map((item) => ({
      id: item.MasterItem_Code,
      text: item.Name,
    }));
    return this.workSiteList;
  }

  fillWorkCategoryDropdown() {
    this.workSiteCategoryList = this.shortCodeWiseObjectMapping['618'].map((item) => ({
      id: item.MasterItem_Code,
      text: item.Name,
    }));
    return this.workSiteCategoryList
  }

  fillWorkManCategoryDropdown() {
    debugger
    this.workmanCategoryList = (this.shortCodeWiseObjectMapping['858'] || []).map((item) => ({
      id: item.MasterItem_Code,
      text: item.Name,
    }));
    return this.workmanCategoryList
  }

  fillValidityPeriodDropdown() {
    this.validityPeriodList = (this.shortCodeWiseObjectMapping['875'] || []).map((item) => ({
      id: item.MasterItem_Code,
      text: item.Name,
    }));
    return this.validityPeriodList
  }

  fillCasteDropdown() {
    this.castList = this.shortCodeWiseObjectMapping['557'].map((item) => ({
      id: item.MasterItem_Code,
      text: item.Name,
    }));
    return this.castList
  }

  fillReligionDropdown() {
    this.religionList = this.shortCodeWiseObjectMapping['362'].map((item) => ({
      id: item.MasterItem_Code,
      text: item.Name,
    }));
    return this.religionList
  }

  fillBloodGroupDropdown() {
    this.bloodGroupList = this.shortCodeWiseObjectMapping['585'].map((item) => ({
      id: item.MasterItem_Code,
      text: item.Name,
    }));
    return this.bloodGroupList
  }

  fillGenderDropdown() {
    this.genderList = this.shortCodeWiseObjectMapping['302'].map((item) => ({
      id: item.MasterItem_Code,
      text: item.Name,
    }));
    return this.genderList
  }

  fillLabourDemandForDropdown() {
    this.labourForList = this.shortCodeWiseObjectMapping['883'].map((item) => ({
      id: item.MasterItem_Code,
      text: item.Name,
    }));
    return this.labourForList
  }

  fillNationalityDropdown() {
    this.nationalityList = this.shortCodeWiseObjectMapping['479'].map((item) => ({
      id: item.MasterItem_Code,
      text: item.Name,
    }));
    return this.nationalityList;
  }

  initializeForm() {
    this.groupHeaders = [
      { label: "Company", colspan: 6 },
      { label: "Compliance Details", colspan: 11 },
      { label: "Associate Information", colspan: 48 },
      { label: "Associate Identity Details", colspan: 17 },
      { label: "Associate Bank Details", colspan: 5 },
      { label: "", colspan: 3 },
      { label: "Referance Contact Details", colspan: 11 },
      { label: "Emergency Contact Details", colspan: 11 },
    ];

    this.columnDefs = [
      { field: "Plant_Code", header: "Plant", type: "dropdown", width: 270, options: this.PlantList },
      { field: "Unit_Code", header: "Unit", type: "dropdown", width: 270, },
      { field: "Department_Code", header: "Department", type: "dropdown", width: 270, },
      { field: "SectionPlantRelationId1", header: "Section", type: "dropdown", width: 270 },
      { field: "SectionPlantRelationId2", header: "Sub-Section 1", type: "dropdown", width: 270 },
      { field: "SectionPlantRelationId3", header: "Sub-Section 2", type: "dropdown", width: 270 },
      { field: "WageCriteria", header: "Wage Criteria", type: "dropdown", width: 270, options: this.wageCriteriaList },
      { field: "ESICNo", header: "ESIC No", type: "input", width: 180 },
      { field: "PFNo", header: "PF No", type: "input", width: 180 },
      { field: "UANNumber", header: "UAN Number", type: "input", width: 180 },
      { field: "DGMSNo", header: "DGMS No", type: "input", width: 150 },
      { field: "LabourDemandFor", header: "Associate Demand For", type: "dropdown", width: 270, options: this.labourForList },
      { field: "Nationality", header: "Nationality", type: "dropdown", width: 270, options: this.nationalityList },
      { field: "WorkSite", header: "Work Site", type: "dropdown", width: 270, options: this.workSiteList },
      { field: "WorkCategory", header: "Work Category", type: "dropdown", width: 270, options: this.workSiteCategoryList },
      { field: "ValidityPeriod", header: "Validity Period", type: "dropdown", width: 270, options: this.validityPeriodList },
      { field: "WorkmanCategory", header: "Associate Category", type: "dropdown", width: 270, options: this.workmanCategoryList },
      { field: "FirstName", header: "First Name", type: "input", width: 180 },
      { field: "FatherHusbandName", header: "Father/Husband Name", type: "input", width: 180 },
      { field: "Relation", header: "Relation", type: "dropdown", width: 270, options: this.relationList },
      { field: "LastName", header: "Last Name", type: "input", width: 180 },
      { field: "BirthDate", header: "Birth Date", type: "date", width: 120 },
      { field: "Gender", header: "Gender", type: "dropdown", width: 120, options: this.genderList },
      { field: "MaritalStatus", header: "Marital Status", type: "dropdown", width: 270, options: this.maritalStatusList },
      { field: "Mobile", header: "Mobile", type: "input", width: 180 },
      { field: "PoliceVerificationDate", header: "Police Verification Date", type: "date", width: 120 },
      { field: "PermanentAddress", header: "P-Address", type: "input", width: 270 },
      { field: "PermanentLandMark", header: "P-Land Mark", type: "input", width: 180 },
      { field: "PermanentArea", header: "P-Area", type: "input", width: 180 },
      { field: "PermanentPincode", header: "P-Pincode", type: "input", width: 180 },
      { field: "PermanentVillageCode", header: "P-Village", type: "dropdown", width: 270 },
      { field: "PermanentState", header: "P-State", type: "readonly", width: 180 },
      { field: "PermanentDistct", header: "P-Distct", type: "readonly", width: 180 },
      { field: "PermanentCity", header: "P-City", type: "readonly", width: 180 },
      { field: "LocalAddress", header: "L-Address", type: "input", width: 180 },
      { field: "LocalLandMark", header: "L-Land Mark", type: "input", width: 180 },
      { field: "LocalArea", header: "L-Area", type: "input", width: 180 },
      { field: "Pincode", header: "Pincode", type: "input", width: 180 },
      { field: "VillageCode", header: "Village", type: "dropdown", width: 270 },
      { field: "State", header: "State", type: "readonly", width: 180 },
      { field: "Distct", header: "Distct", type: "readonly", width: 180 },
      { field: "City", header: "City", type: "readonly", width: 180 },
      { field: "Qualification", header: "Qualification", type: "dropdown", width: 270, options: this.qualificationList },
      { field: "Q_SchoolCollege", header: "Q_School/College", type: "input", width: 150 },
      { field: "Q_YearofPassing", header: "Q_Year of Passing", type: "input", width: 150 },
      { field: "Q_ClassOrGrade", header: "Q_Class Or Grade", type: "input", width: 150 },
      { field: "Q_MediumofInstruction", header: "Q_Medium of Instruction", type: "input", width: 150 },
      { field: "Q_SpecializedCourse", header: "Q_Specialized Course", type: "input", width: 150 },
      { field: "Q_Percentage", header: "Q_Percentage", type: "input", width: 150 },
      { field: "QulificationStream", header: "QS_Qualification", type: "dropdown", width: 270, options: this.qualificationList },
      { field: "QS_SchoolCollege", header: "QS_School/College", type: "input", width: 150 },
      { field: "QS_YearofPassing", header: "QS_Year of Passing", type: "input", width: 150 },
      { field: "QS_ClassOrGrade", header: "QS_Class Or Grade", type: "input", width: 150 },
      { field: "QS_MediumofInstruction", header: "QS_Medium of Instruction", type: "input", width: 150 },
      { field: "QS_SpecializedCourse", header: "QS_Specialized Course", type: "input", width: 150 },
      { field: "QS_Percentage", header: "QS_Percentage", type: "input", width: 150 },
      { field: "TechnicalQulification", header: "TQ_Qualification", type: "dropdown", width: 270, options: this.qualificationList },
      { field: "TQ_SchoolCollege", header: "TQ_School/College", type: "input", width: 150 },
      { field: "TQ_YearofPassing", header: "TQ_Year of Passing", type: "input", width: 150 },
      { field: "TQ_ClassOrGrade", header: "TQ_Class Or Grade", type: "input", width: 150 },
      { field: "TQ_MediumofInstruction", header: "TQ_Medium of Instruction", type: "input", width: 150 },
      { field: "TQ_SpecializedCourse", header: "TQ_Specialized Course", type: "input", width: 150 },
      { field: "TQ_Percentage", header: "TQ_Percentage", type: "input", width: 150 },
      { field: "Cast", header: "Caste", type: "dropdown", width: 270, options: this.castList },
      { field: "Religion", header: "Religion", type: "dropdown", width: 270, options: this.religionList },
      { field: "PANNo", header: "PAN No", type: "input", width: 150 },
      { field: "NameInPAN", header: "NameIn PAN", type: "input", width: 150 },
      { field: "AdhaarCardNumber", header: "Adhaar Card Number", type: "input", width: 150 },
      { field: "NameInAdhaarCard", header: "Name In Adhaar Card", type: "input", width: 150 },
      { field: "VoterIDNumber", header: "Voter-IDNumber", type: "input", width: 150 },
      { field: "NameInVoterID", header: "Name In Voter-ID", type: "input", width: 150 },
      { field: "RationCardNumber", header: "Ration Card Number", type: "input", width: 150 },
      { field: "NameInRationCard", header: "Name In Ration Card", type: "input", width: 150 },
      { field: "DrivingLicenseType", header: "Driving License Type", type: "dropdown", width: 200, options: this.drivingLicenseType },
      { field: "LicenseBatchNumber", header: "License Batch Number", type: "input", width: 150 },
      { field: "DrivingLicenseNumber", header: "Driving License Number", type: "input", width: 130 },
      { field: "NameInDrivingLicense", header: "Name In Driving License", type: "input", width: 150 },
      { field: "DrivingLicenseExpireDate", header: "Driving License Expire Date", type: "date", width: 120 },
      { field: "PassportNumber", header: "Passport Number", type: "input", width: 180 },
      { field: "NameInPassport", header: "Name In Passport", type: "input", width: 200 },
      { field: "PassportRegistraionDate", header: "Passport Registraion Date", type: "date", width: 120 },
      { field: "PassportExpireDate", header: "Passport Expire Date", type: "date", width: 120 },
      { field: "BankName", header: "Bank Name", type: "dropdown", width: 270, options: this.bankNameList },
      { field: "BankBranch", header: "Bank Branch", type: "input", width: 180 },
      { field: "BranchCode", header: "Branch Code", type: "input", width: 180 },
      { field: "PaymentType", header: "Payment Type", type: "dropdown", width: 270, options: this.bankPaymentTypes },
      { field: "AccountNumber", header: "Account Number", type: "input", width: 180 },
      { field: "IFSCCode", header: "IFSC Code", type: "input", width: 180 },
      { field: "NameAsPerBankRecord", header: "Name As Per Bank Record", type: "input", width: 180 },
      { field: "BloodGroup", header: "Blood Group", type: "dropdown", width: 150, options: this.bloodGroupList },
      { field: "SkillType", header: "Skill Type", type: "dropdown", width: 170, options: this.skillList },
      { field: "Trade", header: "Trade", type: "dropdown", width: 270, options: this.tradeList },
      { field: "RFullName", header: "Full Name", type: "input", width: 180 },
      { field: "RRelation", header: "Relation", type: "dropdown", width: 270, options: this.relationList },
      { field: "RMobile", header: " Referance Mobile", type: "input", width: 180 },
      { field: "RAddress", header: "Address", type: "input", width: 180 },
      { field: "RLandMark", header: "Land Mark", type: "input", width: 180 },
      { field: "RArea", header: "Area", type: "input", width: 180 },
      { field: "RPincode", header: "Pincode", type: "input", width: 180 },
      { field: "RVillageCode", header: "Village", type: "dropdown", width: 270 },
      { field: "RState", header: "State", type: "readonly", width: 180 },
      { field: "RDistct", header: "Distct", type: "readonly", width: 180 },
      { field: "RCity", header: "City", type: "readonly", width: 180 },
      { field: "EFullName", header: "Full Name", type: "input", width: 180 },
      { field: "ERelation", header: "Relation", type: "dropdown", width: 270, options: this.relationList },
      { field: "EMobile", header: "Emergency Mobile", type: "input", width: 180 },
      { field: "EAddress", header: "Address", type: "input", width: 180 },
      { field: "ELandMark", header: "Land Mark", type: "input", width: 180 },
      { field: "EArea", header: "Area", type: "input", width: 180 },
      { field: "EPincode", header: "Pincode", type: "input", width: 180 },
      { field: "EVillageCode", header: "Village", type: "dropdown", width: 270 },
      { field: "EState", header: "State", type: "readonly", width: 180 },
      { field: "EDistct", header: "Distct", type: "readonly", width: 180 },
      { field: "ECity", header: "City", type: "readonly", width: 180 },
    ];
  }

  get rows() {
    return this.tableForm.get('rows') as FormArray || new FormArray([]);
  }
 
  validateRow = (rowIndex, field, number) => {
    if(rowIndex == undefined) return;

    const returnObj = {
      isValid: true,
      requireValidation: false,
      msg: "",
    };

    let val = this.labourData[rowIndex][field] || "";
    const requireValidationMessage = "Validation required";

    if (!this.labourData[rowIndex]) {
      return returnObj;
    }

    switch (field) {
      case "Plant_Code":
      case "Unit_Code":
      case "Department_Code":
      case "SectionPlantRelationId1":
      case "SectionPlantRelationId2":
      case "SectionPlantRelationId3":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = `Please select ${field}.`;
        }
        break;
      case "WageCriteria":
        let wageCriteriaVal = this.labourData[rowIndex]["WageCriteria"] || "";

        if (!wageCriteriaVal) {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Wage Criteria.";
          break;
        }

        this.labourData[rowIndex].validation["ESICNo"] = false;
        break;
      case "ESICNo":
        val = this.labourData[rowIndex][field] || "";
        const wageCriteria = this.labourData[rowIndex]["WageCriteria"] || "";

        if (wageCriteria === "Wage / Salary   <   21000.00/- (ESIC Applicable)") {
          if (!val) {
            returnObj.isValid = false;
            returnObj.msg = "ESIC No. is required for this Wage Criteria.";
          } else if (!/^\d+$/.test(val)) {
            returnObj.isValid = false;
            returnObj.msg = "ESIC No. must contain only numbers.";
          } else {
            returnObj.isValid = true;
            returnObj.msg = "";
          }
        } else {
          returnObj.isValid = true;
          returnObj.msg = "";
        }
        break;
      case "VendorCode":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Vendor Code.";
        }
        break;
      case "ContractorName":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Contractor Name.";
        }
        break;
      case "WONo":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter WO No.";
        }
        break;
      case "LabourDemandFor":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Labour Demand For.";
        }
        break;
      case "Nationality":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Nationality.";
        }
        break;
      case "WorkSite":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Work Site.";
        }
        break;
      case "WorkCategory":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Work Category.";
        }
        break;
      case "ValidityPeriod":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Validity Period.";
        }
        break;
      case "PFNo":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter PF No.";
        }
        break;

      case "UANNumber":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter UAN Number.";
        }
        break;
      case "WorkmanCategory":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Associate Category.";
        }
        break;
      case "FirstName":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter First Name.";
        }
        break;
      case "FatherHusbandName":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Father/Husband Name.";
        }
        break;
      case "Relation":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter relation.";
        }
        break;
      case "LastName":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Last Name.";
        }
        break;
      case "BirthDate":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Birth Date.";
        } else {
          const birthDate = moment(val, "YYYY-MM-DD");
          if (!birthDate.isValid()) {
            returnObj.isValid = false;
            returnObj.msg = "Invalid Birth Date format.";
            break;
          }

          const age = moment().diff(birthDate, "years");
          if (age < 18 || age > 65) {
            returnObj.isValid = false;
            returnObj.msg = "Age should be between 18 and 65 years.";
          }
        }
        break;
      case "Gender":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter gender.";
        }
        break;
      case "maritalStatus":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Marital Status.";
        }
        break;
      case "PoliceVerificationDate":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          const passportNumber =
            this.labourData[rowIndex]["PassportNumber"] || "";
          const passportRegistraionDate =
            this.labourData[rowIndex]["PassportRegistraionDate"] || "";
          const passportExpireDate =
            this.labourData[rowIndex]["PassportExpireDate"] || "";
          if (
            passportNumber === "" ||
            (passportRegistraionDate === "" && passportExpireDate === "")
          ) {
            returnObj.isValid = false;
            returnObj.msg = "Please enter Police Verification Date.";
          }
        }
        break;
      case "PermanentPincode":
        val = this.labourData[rowIndex][field] || "";

        if (!val) {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Permanent Pincode.";
        } else if (!this.pincodeMap[val]) {
          returnObj.isValid = false;
          if (this.pincodeNotFoundSet.has(val)) {
            returnObj.msg =
              "Pin code not found in master data. Please contact administrator or change pin code.";
          } else {
            returnObj.requireValidation = true;
            returnObj.msg = requireValidationMessage;
          }
        } else {
          const pincodeDetail = this.pincodeMap[val];
          this.labourData[rowIndex]["PermanentState"] = pincodeDetail.State_Name;
          this.labourData[rowIndex]["PermanentStateCode"] = pincodeDetail.State_Code;
          this.labourData[rowIndex]["PermanentDistctCode"] = pincodeDetail.District_Code;
          this.labourData[rowIndex]["PermanentDistct"] = pincodeDetail.District_Name;
          this.labourData[rowIndex]["PermanentCity"] = pincodeDetail.City_Name;
          this.labourData[rowIndex]["PermanentCityCode"] = pincodeDetail.City_Code;
          this.labourData[rowIndex]["PermanentVillageCode"] = pincodeDetail.Village_Code;

          returnObj.isValid = true;
          returnObj.msg = "";
        }
        break;
      case "LocalAddress":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Local Address.";
        }
        break;
      case "LocalLandMark":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Local Land Mark.";
        }
        break;
      case "LocalArea":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Local Area.";
        }
        break;
      case "Pincode":
        val = this.labourData[rowIndex][field] || "";

        if (!val) {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Pincode.";
        } else if (!this.pincodeMap[val]) {
          returnObj.isValid = false;
          if (this.pincodeNotFoundSet.has(val)) {
            returnObj.msg =
              "Pin code not found in master data. Please contact administrator or change pin code.";
          } else {
            returnObj.requireValidation = true;
            returnObj.msg = requireValidationMessage;
          }
        } else {
          const pincodeDetail = this.pincodeMap[val];
          this.labourData[rowIndex]["State"] = pincodeDetail.State_Name;
          this.labourData[rowIndex]["Distct"] = pincodeDetail.District_Name;
          this.labourData[rowIndex]["City"] = pincodeDetail.City_Name;
          this.labourData[rowIndex]["StateCode"] = pincodeDetail.State_Code;
          this.labourData[rowIndex]["CityCode"] = pincodeDetail.City_Code;
          this.labourData[rowIndex]["DistctCode"] = pincodeDetail.District_Code;
          this.labourData[rowIndex]["VillageCode"] = pincodeDetail.Village_Code;
          returnObj.isValid = true;
          returnObj.msg = "";
        }
        break;
      case "Qualification":
      case "QulificationStream":
      case "TechnicalQulification":
        const qualification = this.labourData[rowIndex]["Qualification"].trim() || "";
        const qualificationStream = this.labourData[rowIndex]["QulificationStream"].trim() || "";
        const technicalQualification = this.labourData[rowIndex]["TechnicalQulification"].trim() || "";
        this.validateQualificationFields(rowIndex);
        if (!qualification && !qualificationStream && !technicalQualification) {
          returnObj.isValid = false;
          returnObj.msg = "Please enter at least one field: Qualification, Qualification Stream, or Technical Qualification.";
        } else {
          returnObj.isValid = true;
          returnObj.msg = "";
        }
        break;
      case "Cast":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Cast.";
        }
        break;
      case "Religion":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Religion.";
        }
        break;
      case "AdhaarCardNumber":
      case "NameInAdhaarCard":
      case "VoterIDNumber":
      case "NameInVoterID":
      case "RationCardNumber":
      case "NameInRationCard":
      case "PANNo":
      case "NameInPAN":
      case "PassportNumber":
      case "NameInPassport":
      case "PassportRegistraionDate":
      case "PassportExpireDate":

        const data = this.labourData[rowIndex];
        const {
          AdhaarCardNumber: AdhaarCard = "",
          NameInAdhaarCard = "",
          VoterIDNumber: VoterID = "",
          NameInVoterID = "",
          RationCardNumber: RationCard = "",
          NameInRationCard = "",
          PANNo: PANNumber = "",
          NameInPAN = "",
          PassportNumber: passportNumber = "",
          NameInPassport: nameInPassport = "",
          PassportRegistraionDate: passportRegDate = "",
          PassportExpireDate: passportExpDate = "",
          Nationality
        } = data;

        const passportRegMoment = this.parseUiDate(passportRegDate);
        const passportExpMoment = this.parseUiDate(passportExpDate);
        const today = moment().startOf("day");
        const isForeigner = Nationality == 569;

        data.validation = data.validation || {};
        if (field === "PassportRegistraionDate") {
          if (isForeigner && !passportRegDate) {
            returnObj.isValid = false;
            returnObj.msg = "Invalid Passport Registration Date format.";
            break;
          }
          if (passportRegDate && !passportRegMoment) {
            returnObj.isValid = false;
            returnObj.msg = "Invalid Passport Registration Date format.";
            break;
          }
          if (passportRegMoment && passportRegMoment.isAfter(today)) {
            returnObj.isValid = false;
            returnObj.msg = "Passport Registration Date cannot be after today.";
            break;
          }
        }

        if (field === "PassportExpireDate") {
          if (isForeigner && !passportExpDate) {
            returnObj.isValid = false;
            returnObj.msg = "Invalid Passport Expiry Date format.";
            break;
          }
          if (passportExpDate && !passportExpMoment) {
            returnObj.isValid = false;
            returnObj.msg = "Invalid Passport Expiry Date format.";
            break;
          }
          if (passportExpMoment && passportExpMoment.isBefore(today)) {
            returnObj.isValid = false;
            returnObj.msg = "Passport Expiry Date cannot be before today.";
            break;
          }
        }

        if (Nationality == 569) {
          if (field === "PassportNumber" && !passportNumber) {
            returnObj.isValid = false;
            returnObj.msg = "Please enter Passport Number.";
            break;
          }
          if (field === "NameInPassport" && !nameInPassport) {
            returnObj.isValid = false;
            returnObj.msg = "Please enter Name on Passport.";
            break;
          }

          returnObj.isValid = true;
          returnObj.msg = "";
          break;
        }

        if (Nationality != 569) {
          if (
            field === "AdhaarCardNumber" || field === "VoterIDNumber" ||
            field === "RationCardNumber" || field === "PANNo"
          ) {
            if (!AdhaarCard && !VoterID && !RationCard && !PANNumber) {
              returnObj.isValid = false;
              returnObj.msg = "Please enter at least one identification document.";
              break;
            }
          }

          const fieldValidations = [
            { fieldName: "AdhaarCardNumber", card: AdhaarCard, name: NameInAdhaarCard, nameField: "NameInAdhaarCard", msg: "Please enter the name associated with the Aadhaar Card." },
            { fieldName: "PANNo", card: PANNumber, name: NameInPAN, nameField: "NameInPAN", msg: "Please enter the name associated with the PAN Card." },
            { fieldName: "VoterIDNumber", card: VoterID, name: NameInVoterID, nameField: "NameInVoterID", msg: "Please enter the name associated with the Voter ID." },
            { fieldName: "RationCardNumber", card: RationCard, name: NameInRationCard, nameField: "NameInRationCard", msg: "Please enter the name associated with the Ration Card." }
          ];

          for (const { card, name, msg, fieldName, nameField } of fieldValidations) {
            if ((field === nameField || field === fieldName) && card && !name) {
              returnObj.isValid = false;
              returnObj.msg = msg;
              break;
            }
          }

          const regexValidations = [
            { fieldName: "VoterIDNumber", value: VoterID, regex: /^[A-Z0-9]{10,15}$/, errorMsg: "Invalid Voter ID format." },
            { fieldName: "RationCardNumber", value: RationCard, regex: /^[A-Z0-9]{8,12}$/, errorMsg: "Invalid Ration Card format." },
            { fieldName: "PANNo", value: PANNumber, regex: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, errorMsg: "Invalid PAN Card format." }
          ];

          for (const { fieldName, value, regex, errorMsg } of regexValidations) {
            if (field === fieldName && value && !regex.test(value)) {
              returnObj.isValid = false;
              returnObj.msg = errorMsg;
              break;
            }
          }

          returnObj.isValid = true;
          returnObj.msg = "";
          break;
        }

      case "BankName":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Bank Name.";
        }
        break;
      case "BankBranch":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Bank Branch.";
        }
        break;
         case "PaymentType":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Payment Type.";
        }
        break;
         case "BranchCode":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Branch Code.";
        }
        break;
      case "AccountNumber":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Account Number.";
        }
        break;
      case "IFSCCode":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter IFSC Code.";
        }
        break;
      case "NameAsPerBankRecord":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Name As Per Bank Record.";
        }
        break;
      case "BloodGroup":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Blood Group.";
        }
        break;
      case "SkillType":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Skill Type.";
        }
        break;
      case "Trade":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Trade.";
        }
        break;
      case "DrivingLicenseNumber":
      case "DrivingLicenseType":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = `Please enter ${field.replace("DrivingLicense", "Driving License ")}.`;
        } else {
          returnObj.isValid = true;
          returnObj.msg = "";
        }
        break;

      case "LicenseBatchNumber":
        val = this.labourData[rowIndex][field] || "";
        if ((this.drivingLicenseRequiredCode.Value === "1" && this.driverTradeCodeArr.includes(this.labourData[rowIndex]["Trade"].toString()))
          && val === ""
        ) {
          returnObj.isValid = true;
          returnObj.msg = "";
        }
        break;
      case "NameInDrivingLicense":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Name In Driving License.";
        } else {
          returnObj.isValid = true;
          returnObj.msg = "";
        }
        break;
      case "DrivingLicenseExpireDate":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Driving License Expire Date.";
        } else {
          const dlExpMoment = this.parseUiDate(val);
          if (!dlExpMoment) {
            returnObj.isValid = false;
            returnObj.msg = "Invalid Driving License Expire Date format.";
          } else if (dlExpMoment.isBefore(moment().startOf("day"))) {
            returnObj.isValid = false;
            returnObj.msg = "Driving License Expire Date cannot be before today.";
          } else {
            returnObj.isValid = true;
            returnObj.msg = "";
          }
        }
        break;
      case "RPincode":
        this.labourData[rowIndex]["RState"] = "";
        this.labourData[rowIndex]["RDistct"] = "";
        this.labourData[rowIndex]["RCity"] = "";
        this.labourData[rowIndex]["RStateCode"] = "";
        this.labourData[rowIndex]["RCityCode"] = "";
        this.labourData[rowIndex]["RDistctCode"] = "";
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
        } else if (!this.pincodeMap[val]) {
          returnObj.isValid = false;
          if (this.pincodeNotFoundSet.has(val)) {
            returnObj.msg =
              " Pin code not found in master data. Please contract administrator or change pin code.";
          } else {
            returnObj.isValid = false;
            returnObj.requireValidation = true;
            returnObj.msg = requireValidationMessage;
          }
        } else {
          const pincodeDetail = this.pincodeMap[val];
          this.labourData[rowIndex]["RState"] = pincodeDetail.State_Name;
          this.labourData[rowIndex]["RDistct"] = pincodeDetail.District_Code;
          this.labourData[rowIndex]["RCity"] = pincodeDetail.City_Name;
          this.labourData[rowIndex]["RStateCode"] = pincodeDetail.State_Code;
          this.labourData[rowIndex]["RCityCode"] = pincodeDetail.City_Code;
          this.labourData[rowIndex]["RDistctCode"] = pincodeDetail.District_Code;
        }
        break;
      case "RMobile":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Emergency Mobile Number.";
        }
        break;
      case "EPincode":
        this.labourData[rowIndex]["EState"] = "";
        this.labourData[rowIndex]["EDistct"] = "";
        this.labourData[rowIndex]["ECity"] = "";
        this.labourData[rowIndex]["EStateCode"] = "";
        this.labourData[rowIndex]["ECityCode"] = "";
        this.labourData[rowIndex]["EDistctCode"] = "";
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
        } else if (!this.pincodeMap[val]) {
          returnObj.isValid = false;
          if (this.pincodeNotFoundSet.has(val)) {
            returnObj.msg =
              " Pin code not found in master data. Please contract administrator or change pin code.";
          } else {
            returnObj.isValid = false;
            returnObj.requireValidation = true;
            returnObj.msg = requireValidationMessage;
          }
        } else {
          const pincodeDetail = this.pincodeMap[val];
          this.labourData[rowIndex]["EState"] = pincodeDetail.State_Name;
          this.labourData[rowIndex]["EDistct"] = pincodeDetail.District_Name;
          this.labourData[rowIndex]["ECity"] = pincodeDetail.City_Name;
          this.labourData[rowIndex]["EStateCode"] = pincodeDetail.State_Code;
          this.labourData[rowIndex]["ECityCode"] = pincodeDetail.City_Code;
          this.labourData[rowIndex]["EDistctCode"] = pincodeDetail.District_Code;
        }
        break;
      case "PermanentVillageCode":
      case "VillageCode":
        val = this.labourData[rowIndex][field] || "";
        if (val === "") {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Village.";
        }
        break;
      case "RVillageCode":
        val = this.labourData[rowIndex]["RPincode"] || "";
        if (val !== "") {
          val = this.labourData[rowIndex][field] || "";
          if (val === "") {
            returnObj.isValid = false;
            returnObj.msg = "Please enter Village.";
          }
        }
        break;
      case "EVillageCode":
        val = this.labourData[rowIndex]["EPincode"] || "";
        if (val !== "") {
          val = this.labourData[rowIndex][field] || "";
          if (val === "") {
            returnObj.isValid = false;
            returnObj.msg = "Please enter Village.";
          }
        }
        break;
      case "EMobile":
        val = this.labourData[rowIndex][field] || "";
        if (val === "" || val.length != 10) {
          returnObj.isValid = false;
          returnObj.msg = "Please enter Emergency Mobile Number.";
        }
        break;
      default:
        break;
    }

    if (!this.labourData[rowIndex].validation) {
      this.labourData[rowIndex].validation = {};
    }

    this.labourData[rowIndex].validation[field] = !returnObj.isValid;
    this.labourData[rowIndex].valid = Object.values(this.labourData[rowIndex].validation).every(val => val === false);
    this.validCount = this.labourData.filter(row => row.valid).length;
    this.invalidCount = this.labourData.length - this.validCount;
    return returnObj;

  };

  getUnitsByPlant(plantCode: number, index) {
    let matchedPlant = this.plantUnitDepartmentTree.find(plant => plantCode == plant.Plantcode0);

    if (matchedPlant) {
      this.labourData[index].UnitList = matchedPlant.Values.map(unit => ({
        id: unit.Unitcode0,
        text: unit.Unit0
      }));
    } else {
      this.labourData[index].UnitList = [];
    }

    const unitList = this.labourData[index].UnitList;

    if (unitList.length === 1) {
      let selectedUnit = unitList[0].id;
      this.labourData[index]["Unit_Code"] = selectedUnit;

      const rowForm = this.rows.at(index);
      if (rowForm) {
        rowForm.patchValue({ Unit_Code: selectedUnit });
      }

      this.getDepartmentsByUnit(selectedUnit, index);
    } else if (unitList.length > 0) {
      unitList.unshift({ id: "", text: "-- Select Dropdown --" });
    }
  }

  onInputChange(event: any, rowIndex: number, field: string) {
  const key = `${rowIndex}_${field}`;
  clearTimeout(this.inputTimers[key]);

  this.inputTimers[key] = setTimeout(() => {
    this.onFieldChange(rowIndex, field, event);
  }, 100);
}


  getDepartmentsByUnit(unitCode: number, index: number) {
    this.labourData[index].DepartmentList = [];
    this.labourData[index].SectionList1 = [];
    this.labourData[index].SectionList2 = [];
    this.labourData[index].SectionList3 = [];

    this.plantUnitDepartmentTree.forEach((plant) => {
      plant.Values.forEach((unit) => {
        if (unit.Unitcode0 == unitCode) {
          this.labourData[index].DepartmentList = unit.Values.map((department) => ({
            id: department.Departmentcode0,
            text: department.Department0
          }));
        }
      });
    });

    if (this.labourData[index].DepartmentList.length === 1) {
      let selectedDepartment = this.labourData[index].DepartmentList[0].id;
      this.labourData[index]["Department_Code"] = selectedDepartment;

      const rowForm = this.rows.at(index);
      if (rowForm) {
        rowForm.patchValue({ Department_Code: selectedDepartment });
      }
      this.getSectionsByDepartment(selectedDepartment, index);
    } else if (this.labourData[index].DepartmentList.length > 0) {
      this.labourData[index].DepartmentList.unshift({ id: "", text: "-- Select Dropdown --" });
    }
  }

  getSectionsByDepartment(departmentCode: number, index: number) {
    this.labourData[index].SectionList1 = [];
    this.labourData[index].SectionList2 = [];
    this.labourData[index].SectionList3 = [];

    this.plantUnitDepartmentTree.forEach((plant) => {
      plant.Values.forEach((unit) => {
        unit.Values.forEach((department) => {
          if (department.Departmentcode0 == departmentCode) {
            this.labourData[index].SectionList1 = department.Values.map((section) => ({
              id: section.Sectioncode0,
              text: section.SectionName0
            }));
          }
        });
      });
    });

    if (this.labourData[index].SectionList1.length === 1) {
      let selectedSection = this.labourData[index].SectionList1[0].id;
      this.labourData[index]["SectionPlantRelationId1"] = selectedSection;

      const rowForm = this.rows.at(index);
      if (rowForm) {
        rowForm.patchValue({ SectionPlantRelationId1: selectedSection });
      }

      this.getSectionsBySection1(selectedSection, index);
    } else if (this.labourData[index].SectionList1.length > 0) {
      this.labourData[index].SectionList1.unshift({ id: "", text: "-- Select Dropdown --" });
    }
  }

  getSectionsBySection1(Sectioncode1: number, index: number) {
    this.labourData[index].SectionList2 = [];
    this.labourData[index].SectionList3 = [];

    this.plantUnitDepartmentTree.forEach((plant) => {
      plant.Values.forEach((unit) => {
        unit.Values.forEach((department) => {
          department.Values.forEach((section) => {
            section.Values.forEach((section1) => {
              if (section1.Sectioncode1 == Sectioncode1) {
                if (Array.isArray(section1.Values)) {
                  this.labourData[index].SectionList2 = section1.Values.map((sectionItem) => ({
                    id: sectionItem.Sectioncode2,
                    text: sectionItem.SectionName2
                  }));
                }
              }
            });
          });
        });
      });
    });

    if (this.labourData[index].SectionList2.length === 1) {
      this.getSectionsBySection2(this.labourData[index].SectionList2[0].id, index);
      this.labourData[index]["SectionPlantRelationId2"] = this.labourData[index].SectionList2[0].id

      const rowForm = this.rows.at(index);
      if (rowForm) {
        rowForm.patchValue({ SectionPlantRelationId2: this.labourData[index].SectionList2[0].id });
      }

    } else if (this.labourData[index].SectionList2.length > 0) {
      this.labourData[index].SectionList2.unshift({ id: "", text: "-- Select Dropdown --" });
    }
  }

  getSectionsBySection2(Sectioncode3: number, index: number) {
    this.labourData[index].SectionList3 = [];

    this.plantUnitDepartmentTree.forEach((plant) => {
      plant.Values.forEach((unit) => {
        unit.Values.forEach((department) => {
          department.Values.forEach((Section) => {
            Section.Values.forEach((Section1) => {
              Section1.Values.forEach((Section2) => {
                if (Section2.Sectioncode2 == Sectioncode3) {
                  this.labourData[index].SectionList3 = [{
                    id: Section2.Sectioncode2,
                    text: Section2.SectionName2,
                    sectionPlantId: Section2.LevelID2
                  }];
                }
              });
            });
          });
        });
      });
    });
    if (this.labourData[index].SectionList3.length === 1) {
      this.labourData[index]["SectionPlantRelationId3"] = this.labourData[index].SectionList3[0].id

      const rowForm = this.rows.at(index);
      if (rowForm) {
        rowForm.patchValue({ SectionPlantRelationId3: this.labourData[index].SectionList3[0].id });
      }

    } else if (this.labourData[index].SectionList3.length === 1) {
      this.labourData[index].SectionList3.unshift({ id: "", text: "-- Select Dropdown --" });
    }
  }

  onFieldChange(rowIndex: number, field: string, event?: any) {
    const row = this.rows.at(rowIndex);
    if (!this.labourData[rowIndex]) {
      this.labourData[rowIndex] = { validation: {}, ...row.value };
    }
  
    let updatedValue = event ? event.target.value : row.value[field];
  
    if (["EMobile", "RMobile", "Mobile"].includes(field)) {
      updatedValue = updatedValue.replace(/\D/g, '').substring(0, 10);
    }
  
    this.labourData[rowIndex][field] = updatedValue;
  
    const dependentFields = ["Plant_Code", "Unit_Code", "Department_Code", "SectionPlantRelationId1", "SectionPlantRelationId2"];
    if (dependentFields.includes(field)) {
      this.fetchDataBasedOnField(rowIndex, field);
    }
  
    const pincodeFields = ["Pincode", "PermanentPincode", "RPincode", "EPincode"];
    if (pincodeFields.includes(field)) {
      const pincodeList = pincodeFields
        .map(p => this.labourData[rowIndex][p])
        .filter(p => !!p);
      this.getPincodeDetails(pincodeList, rowIndex, field);
    }
  
    const villageFieldMap = {
      EVillageCode: { code: "EPincode", state: "EState", district: "EDistct", city: "ECity" },
      RVillageCode: { code: "RPincode", state: "RState", district: "RDistct", city: "RCity" },
      PermanentVillageCode: { code: "PermanentPincode", state: "PermanentState", district: "PermanentDistct", city: "PermanentCity" },
      VillageCode: { code: "Pincode", state: "State", district: "Distct", city: "City" }
    };
  
    if (villageFieldMap[field]) {
      const { code, state, district, city } = villageFieldMap[field];
      const pincode = this.labourData[rowIndex][code];
      const villageId = this.labourData[rowIndex][field];
      const villageList = (this.pincodeMap[pincode] || {}).VillageList || [];
      const selectedVillage = villageList.find(v => v.id == villageId);
      if (selectedVillage) {

  Promise.resolve().then(() => {

    const stateValue = selectedVillage.State || 0;
    const districtValue = selectedVillage.District || 0;
    const cityValue = selectedVillage.City || 0;

    //  Update Form controls
    const stateCtrl = row.get(state);
    const districtCtrl = row.get(district);
    const cityCtrl = row.get(city);

    if (stateCtrl) stateCtrl.setValue(stateValue, { emitEvent: false });
    if (districtCtrl) districtCtrl.setValue(districtValue, { emitEvent: false });
    if (cityCtrl) cityCtrl.setValue(cityValue, { emitEvent: false });

    //  Update labourData AT THE SAME TIME
    this.labourData[rowIndex][state] = stateValue;
    this.labourData[rowIndex][district] = districtValue;
    this.labourData[rowIndex][city] = cityValue;

    // Trigger UI update (OnPush)
    this.cdr.markForCheck();
  });

}

    }
  
// Fields that REQUIRE full row validation
const fullRowValidationFields = [
  'Plant_Code','Unit_Code','Department_Code',
  'SectionPlantRelationId1','SectionPlantRelationId2','SectionPlantRelationId3',
  'Pincode','PermanentPincode','RPincode','EPincode',
  'VillageCode','PermanentVillageCode','RVillageCode','EVillageCode'
];

if (fullRowValidationFields.indexOf(field) !== -1) {

  // FULL ROW VALIDATION (safe & intentional)
  this.validateEntireRow(rowIndex);

} else {

  // Normal single-field validation
  this.validateRow(rowIndex, field, -4);

  // Limited dependent validations
  const dependentFieldsMap = {
    WageCriteria: ['ESICNo'],
    Qualification: [
      'Q_SchoolCollege','Q_YearofPassing','Q_ClassOrGrade',
      'Q_MediumofInstruction','Q_SpecializedCourse','Q_Percentage'
    ],
    QulificationStream: [
      'QS_SchoolCollege','QS_YearofPassing','QS_ClassOrGrade',
      'QS_MediumofInstruction','QS_SpecializedCourse','QS_Percentage'
    ],
    TechnicalQulification: [
      'TQ_SchoolCollege','TQ_YearofPassing','TQ_ClassOrGrade',
      'TQ_MediumofInstruction','TQ_SpecializedCourse','TQ_Percentage'
    ]
  };

  (dependentFieldsMap[field] || []).forEach(dep =>
    this.validateRow(rowIndex, dep, -4)
  );
}

// update UI for OnPush
this.cdr.markForCheck();


  }

  private validateEntireRow(rowIndex: number): void {
  const row = this.labourData[rowIndex];
  if (!row) return;

  for (const field in row) {
    if (row.hasOwnProperty(field) && field !== 'validation') {
      this.validateRow(rowIndex, field, -4);
    }
  }
}


  fetchDataBasedOnField(rowIndex: number, field: string) {
    if (field === 'Plant_Code') {
      this.labourData[rowIndex]["Unit_Code"] = null
      this.labourData[rowIndex]["Department_Code"] = null
      this.labourData[rowIndex]["SectionPlantRelationId1"] = null
      this.labourData[rowIndex]["SectionPlantRelationId2"] = null
      this.labourData[rowIndex]["SectionPlantRelationId3"] = null
      this.getUnitsByPlant(this.labourData[rowIndex].Plant_Code, rowIndex);
    } else if (field === 'Unit_Code') {
      this.labourData[rowIndex]["Department_Code"] = null
      this.labourData[rowIndex]["SectionPlantRelationId1"] = null
      this.labourData[rowIndex]["SectionPlantRelationId2"] = null
      this.labourData[rowIndex]["SectionPlantRelationId3"] = null
      this.getDepartmentsByUnit(this.labourData[rowIndex].Unit_Code, rowIndex);
    } else if (field === 'Department_Code') {
      this.labourData[rowIndex]["SectionPlantRelationId1"] = null
      this.labourData[rowIndex]["SectionPlantRelationId2"] = null
      this.labourData[rowIndex]["SectionPlantRelationId3"] = null
      this.getSectionsByDepartment(this.labourData[rowIndex].Department_Code, rowIndex);
    } else if (field === 'SectionPlantRelationId1') {
      this.labourData[rowIndex]["SectionPlantRelationId2"] = null
      this.labourData[rowIndex]["SectionPlantRelationId3"] = null
      this.getSectionsBySection1(this.labourData[rowIndex].SectionPlantRelationId1, rowIndex);
    } else if (field === 'SectionPlantRelationId2') {
      this.labourData[rowIndex]["SectionPlantRelationId3"] = null
      this.getSectionsBySection2(this.labourData[rowIndex].SectionPlantRelationId2, rowIndex);
    }
  }

  validateQualificationFields(rowIndex: number): { isValid: boolean; msg: string } {
    const row = this.labourData[rowIndex];

    const qualification = row["Qualification"].trim() || "";
    const qualificationStream = row["QulificationStream"].trim() || "";
    const technicalQualification = row["TechnicalQulification"].trim() || "";

    const mandatoryFields: { [key: string]: string[] } = {
      Qualification: [
        "Q_SchoolCollege", "Q_YearofPassing", "Q_ClassOrGrade",
        "Q_MediumofInstruction", "Q_SpecializedCourse", "Q_Percentage"
      ],
      QulificationStream: [
        "QS_SchoolCollege", "QS_YearofPassing", "QS_ClassOrGrade",
        "QS_MediumofInstruction", "QS_SpecializedCourse", "QS_Percentage"
      ],
      TechnicalQulification: [
        "TQ_SchoolCollege", "TQ_YearofPassing", "TQ_ClassOrGrade",
        "TQ_MediumofInstruction", "TQ_SpecializedCourse", "TQ_Percentage"
      ]
    };

    let isValid = true;

    if (!this.labourData[rowIndex].validation) {
      this.labourData[rowIndex].validation = {};
    }

    if (qualification) {
      for (const field of mandatoryFields.Qualification) {
        if (!row[field].trim()) {
          this.labourData[rowIndex].validation[field] = true;
          isValid = false;
        } else {
          this.labourData[rowIndex].validation[field] = false;
        }
      }
    }

    if (qualificationStream) {
      for (const field of mandatoryFields.QulificationStream) {
        if (!row[field].trim()) {
          this.labourData[rowIndex].validation[field] = true;
          isValid = false;
        } else {
          this.labourData[rowIndex].validation[field] = false;
        }
      }
    }

    if (technicalQualification) {
      for (const field of mandatoryFields.TechnicalQulification) {
        if (!row[field].trim()) {
          this.labourData[rowIndex].validation[field] = true;
          isValid = false;
        } else {
          this.labourData[rowIndex].validation[field] = false;
        }
      }
    }

    return { isValid, msg: isValid ? "" : "Please fill all required fields." };
  }

  isFieldInvalid(rowIndex: number, field: string): boolean {
    return this.labourData[rowIndex] && this.labourData[rowIndex].validation ? this.labourData[rowIndex].validation[field] === true : false;
  }

  assignDataToArray() {
    this.getPlantList();
    this.fillLabourDemandForDropdown();
    this.fillNationalityDropdown();
    this.fillWorkSiteDropdown();
    this.fillWorkCategoryDropdown();
    this.fillValidityPeriodDropdown();
    this.fillWorkManCategoryDropdown();
    this.fillRelationDropdown();
    this.fillGenderDropdown();
    this.fillMaritalStatusDropdown();
    this.populateQualificationList();
    // this.fillQulificationStreamDropdown();
    // this.fillTechnicalQulificationDropdown();
    this.fillBloodGroupDropdown();
    this.fillBankDetailDropdown();
    this.fillReligionDropdown();
    this.fillCasteDropdown();
    this.fillDrivingLicenseTypeDropdown();
    this.fillPaymentTypeDropdown();
  }

  createRowForm(row): FormGroup {
    return this.fb.group({
      Plant_Code: [row.Plant_Code || ''],
      Unit_Code: [row.Unit_Code || ''],
      WageCriteria: [row.WageCriteria || ''],
      LabourDemandFor: [row.LabourDemandFor || ''],
      Nationality: [row.Nationality || ''],
      WorkSite: [row.WorkSite || ''],
      WorkCategory: [row.WorkCategory || ''],
      ValidityPeriod: [row.ValidityPeriod || ''],
      PFNo: [row.PFNo || ''],
      UANNumber: [row.UANNumber || ''],
      Department_Code: [row.Department_Code || ''],
      SectionPlantRelationId1: [row.SectionPlantRelationId1 || ''],
      SectionPlantRelationId2: [row.SectionPlantRelationId2 || ''],
      SectionPlantRelationId3: [row.SectionPlantRelationId3 || ''],
      ESICNo: [row.ESICNo || ''],
      DGMSNo: [row.DGMSNo || ''],
      WorkmanCategory: [row.WorkmanCategory || ''],
      FirstName: [row.FirstName || ''],
      FatherHusbandName: [row.FatherHusbandName || ''],
      Relation: [row.Relation || ''],
      LastName: [row.LastName || ''],
      BirthDate: [row.BirthDate || ''],
      Gender: [row.Gender || ''],
      MaritalStatus: [row.MaritalStatus || ''],
      Mobile: [row.Mobile || ''],
      PoliceVerificationDate: [row.PoliceVerificationDate || ''],
      PermanentAddress: [row.PermanentAddress || ''],
      PermanentLandMark: [row.PermanentLandMark || ''],
      PermanentArea: [row.PermanentArea || ''],
      PermanentPincode: [row.PermanentPincode || ''],
      PermanentVillageCode: [row.PermanentVillageCode || ''],
      PermanentState: [row.PermanentState || ''],
      PermanentDistct: [row.PermanentDistct || ''],
      PermanentCity: [row.PermanentCity || ''],
      LocalAddress: [row.LocalAddress || ''],
      LocalLandMark: [row.LocalLandMark || ''],
      LocalArea: [row.LocalArea || ''],
      Pincode: [row.Pincode || ''],
      VillageCode: [row.VillageCode || ''],
      State: [row.State || ''],
      Distct: [row.Distct || ''],
      City: [row.City || ''],
      Qualification: [row.Qualification || ''],
      Q_SchoolCollege: [row.Q_SchoolCollege || ''],
      Q_YearofPassing: [row.Q_YearofPassing || ''],
      Q_ClassOrGrade: [row.Q_ClassOrGrade || ''],
      Q_MediumofInstruction: [row.Q_MediumofInstruction || ''],
      Q_SpecializedCourse: [row.Q_SpecializedCourse || ''],
      Q_Percentage: [row.Q_Percentage || ''],
      QulificationStream: [row.QulificationStream || ''],
      QS_SchoolCollege: [row.QS_SchoolCollege || ''],
      QS_YearofPassing: [row.QS_YearofPassing || ''],
      QS_ClassOrGrade: [row.QS_ClassOrGrade || ''],
      QS_MediumofInstruction: [row.QS_MediumofInstruction || ''],
      QS_SpecializedCourse: [row.QS_SpecializedCourse || ''],
      QS_Percentage: [row.QS_Percentage || ''],
      TechnicalQulification: [row.TechnicalQulification || ''],
      TQ_SchoolCollege: [row.TQ_SchoolCollege || ''],
      TQ_YearofPassing: [row.TQ_YearofPassing || ''],
      TQ_ClassOrGrade: [row.TQ_ClassOrGrade || ''],
      TQ_MediumofInstruction: [row.TQ_MediumofInstruction || ''],
      TQ_SpecializedCourse: [row.TQ_SpecializedCourse || ''],
      TQ_Percentage: [row.TQ_Percentage || ''],
      Cast: [row.Cast || ''],
      Religion: [row.Religion || ''],
      PANNo: [row.PANNo || ''],
      NameInPAN: [row.NameInPAN || ''],
      AdhaarCardNumber: [row.AdhaarCardNumber || ''],
      NameInAdhaarCard: [row.NameInAdhaarCard || ''],
      VoterIDNumber: [row.VoterIDNumber || ''],
      NameInVoterID: [row.NameInVoterID || ''],
      RationCardNumber: [row.RationCardNumber || ''],
      NameInRationCard: [row.NameInRationCard || ''],
      LicenseBatchNumber: [row.LicenseBatchNumber || ''],
      DrivingLicenseType: [row.DrivingLicenseType || ''],
      DrivingLicenseNumber: [row.DrivingLicenseNumber || ''],
      NameInDrivingLicense: [row.NameInDrivingLicense || ''],
      DrivingLicenseExpireDate: [row.DrivingLicenseExpireDate || ''],
      PassportNumber: [row.PassportNumber || ''],
      NameInPassport: [row.NameInPassport || ''],
      PassportRegistraionDate: [row.PassportRegistraionDate || ''],
      PassportExpireDate: [row.PassportExpireDate || ''],
      BankName: [row.BankName || ''],
      BankBranch: [row.BankBranch || ''],
      BranchCode: [row.BranchCode || ''],
      PaymentType: [row.PaymentType || ''],
      AccountNumber: [row.AccountNumber || ''],
      IFSCCode: [row.IFSCCode || ''],
      NameAsPerBankRecord: [row.NameAsPerBankRecord || ''],
      BloodGroup: [row.BloodGroup || ''],
      SkillType: [row.SkillType || ''],
      Trade: [row.Trade || ''],
      RFullName: [row.RFullName || ''],
      RRelation: [row.RRelation || ''],
      RAddress: [row.RAddress || ''],
      RLandMark: [row.RLandMark || ''],
      RArea: [row.RArea || ''],
      RPincode: [row.RPincode || ''],
      RVillageCode: [row.RVillageCode || ''],
      RState: [row.RState || ''],
      RDistct: [row.RDistct || ''],
      RCity: [row.RCity || ''],
      EFullName: [row.EFullName || ''],
      ERelation: [row.ERelation || ''],
      EAddress: [row.EAddress || ''],
      ELandMark: [row.ELandMark || ''],
      EArea: [row.EArea || ''],
      EPincode: [row.EPincode || ''],
      EVillageCode: [row.EVillageCode || ''],
      EState: [row.EState || ''],
      EDistct: [row.EDistct || ''],
      ECity: [row.ECity || ''],
      RMobile: [row.RMobile || ''],
      EMobile: [row.EMobile || '']
    });
  }

  PlantList: any[] = [];
  UnitList: any[] = [];
  DepartmentList: any[] = [];
  SectionList1: any[] = [];
  SectionList2: any[] = [];
  SectionList3: any[] = [];
  uploadExcelData: any[] = [];
  getPlantList() {
    if (!this.plantUnitDepartmentTree || this.plantUnitDepartmentTree.length === 0) {
      return;
    }

    this.PlantList = this.plantUnitDepartmentTree.map(plant => ({
      id: plant.Plantcode0,
      text: plant.Plant0
    }));

  }

  loadSkillList() {
    this.labourService.getSkillType().subscribe((response: any) => {
      this.skillList = response.map((item: any) => ({
        id: item.Skill_Code,
        text: item.SkillName,
      }));
    });
    this.skillList.unshift({ id: "", text: "-- Select Dropdown --" });
    return this.skillList;
  }

  loadTradeList() {
    this.commonApiService.getAllTradeMaster(this.tradeMasterParams).subscribe((response: any) => {
      this.tradeList = response.map((item: any) => ({
        id: item.Trade_code,
        text: item.Name,
      }));
    });
    this.tradeList.unshift({ id: "", text: "-- Select Dropdown --" });
    return this.tradeList;
  }

  removeRow(index: number) {
    this.rows.removeAt(index);
    this.labourData.splice(index, 1);
    this.totalExcelData = this.labourData.length;
  }

  submit() {
    console.log(this.tableForm.value);
  }

  removeSelectedRows() {
    this.tableData = this.tableData.filter(row => !row.selected);
  }

  selectedFileName: string | null = null;

  onFileChange($event) {
    const inputElement = event.target as HTMLInputElement;

    if (inputElement.files && inputElement.files.length > 0) {
      this.selectedFileName = inputElement.files[0].name;
    } else {
      this.selectedFileName = null;
    }

    this.validateFile($event.target);
  }

  validateFile(target) {
    this.fileError = "";
    if (target.files.length === 0) {
      this.fileError = "Please select Excel file";
      target.value = "";
      return false;
    }

    if (target.files.length > 1) {
      this.fileError = "Cannot use multiple files";
      target.value = "";
      return false;
    }

    if (
      !(
        target.files[0].name.endsWith(".xlsx") ||
        target.files[0].name.endsWith(".xls")
      )
    ) {
      this.fileError = "Invalid File format, please select Excel file only.";
      target.value = "";
      return false;
    }

    return true;
  }

  onUploadFile() {
    if (this.validateFile(this.fileInput.nativeElement)) {
      this.isLoading = true;
      this.dataSet = true;
      const reader = new FileReader();

      reader.onload = (e: Event) => {
        if (e.target) {
          const bstr = reader.result as ArrayBuffer;
          const wb = XLSX.read(bstr, { type: "array", cellDates: true });

          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];

          const fileContent = XLSX.utils.sheet_to_json(ws, {
            header: 1,
            blankrows: false,
            defval: null,
            raw: true,
          });

          if (!fileContent || fileContent.length === 0) {
            this.isLoading = false;
            this.dataSet = false;
            this.selectedFileName = null
            this.fileError = "Please select a file to upload.";
            return;
          }

          const labourData = [];
          const colgrps = fileContent.shift();
          const keys: any = fileContent.shift();

          const data = fileContent.map((e) => {
            const obj = {};
            for (let i = 0; i < keys.length; i++) {
              obj[keys[i]] = e[i];
            }
            return obj;
          });

          if (data.length === 0) {
            this.fileError = "At least one record should be available in the file to upload.";
            this.isLoading = false;
            this.dataSet = false;
            this.selectedFileName = null
            return;
          }

          if (data.length > Number(this.globalSettingData[0].Value)) {
            this.fileError = `Maximum ${Number(this.globalSettingData[0].Value)} records are allowed to import.`;
            this.isLoading = false;
            this.dataSet = false;
            this.selectedFileName = null
            return;
          }
          localStorage.setItem("xlsx_data", JSON.stringify(data));
          this.bindExcelData(this.removeSortCharFromKeys(data));
        }
      };

      reader.readAsArrayBuffer(this.fileInput.nativeElement.files[0]);
    }
  }

  private parseExcelDate(value: any): string {
    if (value === null || value === undefined || value === "") {
      return "";
    }

    if (value instanceof Date && !isNaN(value.getTime())) {
      return moment(value).format("YYYY-MM-DD");
    }

    if (typeof value === "number") {
      const parsed = XLSX.SSF.parse_date_code(value);
      if (parsed && parsed.y && parsed.m && parsed.d) {
        return moment(
          { year: parsed.y, month: parsed.m - 1, day: parsed.d }
        ).format("YYYY-MM-DD");
      }
    }

    const text = value.toString().trim();
    const m = moment(text, ["MM/DD/YYYY", "DD/MM/YYYY", "YYYY-MM-DD"], true);
    return m.isValid() ? m.format("YYYY-MM-DD") : "";
  }

  private parseUiDate(value: any): moment.Moment | null {
    if (value === null || value === undefined || value === "") {
      return null;
    }
    if (value instanceof Date && !isNaN(value.getTime())) {
      return moment(value);
    }
    if (typeof value === "number") {
      const parsed = XLSX.SSF.parse_date_code(value);
      if (parsed && parsed.y && parsed.m && parsed.d) {
        return moment({ year: parsed.y, month: parsed.m - 1, day: parsed.d });
      }
    }
    const text = value.toString().trim();
    const m = moment(text, ["YYYY-MM-DD", "DD-MM-YYYY", "MM/DD/YYYY", "DD/MM/YYYY"], true);
    return m.isValid() ? m : null;
  }

 async bindExcelData(data) {
    this.assignDataToArray();
    const importData = [];

    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      if (element && Object.keys(element).length > 0) {
        const dob = this.parseExcelDate(element["Birth Date"]);
        const dled = this.parseExcelDate(element["Driving License Expire Date"]);
        const pvDate = this.parseExcelDate(element["Police Verification Date"]);
        // Accept both correct and legacy/typo Excel headers.
        const prDate = this.parseExcelDate(
          element["Passport Registration Date"] ? element["Passport Registration Date"] :  element["Passport Registraion Date"]
        );
        const peDate = this.parseExcelDate(element["Passport Expire Date"]);

        let gender = (element["Gender"] || "").toString().trim();
        let genderFound = false;
        if (gender !== "") {
          for (let p = 0; p < this.genderList.length; p++) {
            if (this.genderList[p].text === gender) {
              gender = String(this.genderList[p].id);
              genderFound = true;
              break;
            }
          }
        }
        if (!genderFound) {
          gender = "";
        }

        let maritalStatus = (element["Marital Status"] || "").toString().trim();
        let maritalStatusFound = false;
        if (maritalStatus !== "") {
          for (let p = 0; p < this.maritalStatusList.length; p++) {
            if (
              this.maritalStatusList[p].text.toLowerCase() ===
              maritalStatus.toLowerCase()
            ) {
              maritalStatus = String(this.maritalStatusList[p].id);
              maritalStatusFound = true;
              break;
            }
          }
        }
        if (!maritalStatusFound) {
          maritalStatus = "";
        }

        let relation = (element["Relation"] || "").toString().trim();
        let relationFound = false;
        if (relation !== "") {
          for (let p = 0; p < this.relationList.length; p++) {
            if (
              this.relationList[p].text.toLowerCase() === relation.toLowerCase()
            ) {
              relation = String(this.relationList[p].id);
              relationFound = true;
              break;
            }
          }
        }
        if (!relationFound) {
          relation = "";
        }

        let rrelation = (element["R-Relation"] || "").toString().trim();
        let rrelationFound = false;
        if (rrelation !== "") {
          for (let p = 0; p < this.relationList.length; p++) {
            if (
              this.relationList[p].text.toLowerCase() === rrelation.toLowerCase()
            ) {
              rrelation = String(this.relationList[p].id);
              rrelationFound = true;
              break;
            }
          }
        }
        if (!rrelationFound) {
          rrelation = "";
        }

        let erelation = (element["E-Relation"] || "").toString().trim();
        let erelationFound = false;
        if (erelation !== "") {
          for (let p = 0; p < this.relationList.length; p++) {
            if (
              this.relationList[p].text.toLowerCase() === erelation.toLowerCase()
            ) {
              erelation = String(this.relationList[p].id);
              erelationFound = true;
              break;
            }
          }
        }
        if (!erelationFound) {
          erelation = "";
        }

        let qualification = (element["Qualification"] || "").toString().trim();
        let qualificationFound = false;
        let isQualificationIlletrate = false;
        if (qualification !== "") {
          for (let p = 0; p < this.qualificationList.length; p++) {
            if (this.qualificationList[p].text.toLowerCase() === qualification.toLowerCase()) {
              qualification = String(this.qualificationList[p].id);
              if (this.qualificationList[p].ShortCode === "GM332") {
                isQualificationIlletrate = true;
              }
              qualificationFound = true;
              break;
            }
          }
        }
        if (!qualificationFound) {
          qualification = "";
        }

        let qulificationStream = (element["QS_Qualification"] || "").toString().trim();
        let qulificationStreamFound = false;
        if (isQualificationIlletrate) {
          for (let p = 0; p < this.qualificationList.length; p++) {
            if (this.qualificationList[p].ShortCode === "GM332") {
              qulificationStream = String(this.qualificationList[p].id);
              qulificationStreamFound = true;
              break;
            }
          }
        } else {
          if (qulificationStream !== "") {
            for (let p = 0; p < this.qualificationList.length; p++) {
              if (
                this.qualificationList[p].text.toLowerCase() ===
                qulificationStream.toLowerCase()
              ) {
                qulificationStream = String(this.qualificationList[p].id);
                qulificationStreamFound = true;
                break;
              }
            }
          }
        }
        if (!qulificationStreamFound) {
          qulificationStream = "";
        }

        let technicalQulification = (element["TQ_Qualification"] || "").toString().trim();
        let technicalQulificationFound = false;
        if (isQualificationIlletrate) {
          for (let p = 0; p < this.qualificationList.length; p++) {
            if (this.qualificationList[p].ShortCode === "GM332") {
              technicalQulification = String(
                this.qualificationList[p].id
              );
              technicalQulificationFound = true;
              break;
            }
          }
        } else {
          if (technicalQulification !== "") {
            for (let p = 0; p < this.qualificationList.length; p++) {
              if (this.qualificationList[p].text.toLowerCase() === technicalQulification.toLowerCase()) {
                technicalQulification = String(this.qualificationList[p].id);
                technicalQulificationFound = true;
                break;
              }
            }
          }
        }
        if (!technicalQulificationFound) {
          technicalQulification = "";
        }

        let cast = (element["Caste"] || "").toString().trim();
        let castFound = false;
        if (cast !== "") {
          for (let p = 0; p < this.castList.length; p++) {
            if (this.castList[p].text === cast) {
              cast = String(this.castList[p].id);
              castFound = true;
              break;
            }
          }
        }
        if (!castFound) {
          cast = "";
        }

        let religion = (element["Religion"] || "").toString().trim();
        let religionFound = false;
        if (religion !== "") {
          for (let p = 0; p < this.religionList.length; p++) {
            if (this.religionList[p].text === religion) {
              religion = String(this.religionList[p].id);
              religionFound = true;
              break;
            }
          }
        }
        if (!religionFound) {
          religion = "";
        }

        let bankName = (element["Bank Name"] || "").toString().trim();
        let bankNameFound = false;
        if (bankName !== "") {
          for (let p = 0; p < this.bankNameList.length; p++) {
            if (this.bankNameList[p].text.toLowerCase() === bankName.toLowerCase()) {
              bankName = String(this.bankNameList[p].id);
              bankNameFound = true;
              break;
            }
          }
        }
        if (!bankNameFound) {
          bankName = "";
        }

        let bloodGroup = (element["Blood Group"] || "").toString().trim();
        let bloodGroupFound = false;
        if (bloodGroup !== "") {
          for (let p = 0; p < this.bloodGroupList.length; p++) {
            if (
              this.bloodGroupList[p].text.toLowerCase() ===
              bloodGroup.toLowerCase()
            ) {
              bloodGroup = String(this.bloodGroupList[p].id);
              bloodGroupFound = true;
              break;
            }
          }
        }
        if (!bloodGroupFound) {
          bloodGroup = "";
        }

        let skill = (element["Skill Type"] || "").toString().trim();
        let skillFound = false;
        if (skill !== "") {
          for (let p = 0; p < this.skillList.length; p++) {
            if (this.skillList[p].text.toLowerCase() === skill.toLowerCase()) {
              skill = String(this.skillList[p].id);
              skillFound = true;
              break;
            }
          }
        }
        if (!skillFound) {
          skill = "";
        }

        let trade = (element["Trade"] || "").toString().trim();

        const matchedTrade = trade ? this.tradeList.find((item) => item.text.toLowerCase() === trade.toLowerCase()) : null;

        trade = matchedTrade ? String(matchedTrade.id) : "";

        let workSite = (element["Work Site"] || "").toString().trim();
        let workSiteFound = false;
        if (workSite !== "") {
          for (let p = 0; p < this.workSiteList.length; p++) {
            if (
              this.workSiteList[p].text.toLowerCase() === workSite.toLowerCase()
            ) {
              workSite = String(this.workSiteList[p].id);
              workSiteFound = true;
              break;
            }
          }
        }
        if (!workSiteFound) {
          workSite = "";
        }

        let workCategory = (element["Work Category"] || "").toString().trim();
        let workCategoryFound = false;
        if (workCategory !== "") {
          for (let p = 0; p < this.workSiteCategoryList.length; p++) {
            if (
              this.workSiteCategoryList[p].text.toLowerCase() === workCategory.toLowerCase()
            ) {
              workCategory = String(this.workSiteCategoryList[p].id);
              workCategoryFound = true;
              break;
            }
          }
        }
        if (!workCategoryFound) {
          workCategory = "";
        }

        let nationality = (element["Nationality"] || "").toString().trim();
        let nationalityFound = false;
        if (nationality !== "") {
          for (let p = 0; p < this.nationalityList.length; p++) {
            if (
              this.nationalityList[p].text.toLowerCase() ===
              nationality.toLowerCase()
            ) {
              nationality = String(this.nationalityList[p].id);
              nationalityFound = true;
              break;
            }
          }
        }
        if (!nationalityFound) {
          nationality = "";
        }

        let labourDemand = (element["Labour Demand For"] || "").toString().trim();
        let LabourDemandForFound = false;
        if (labourDemand !== "") {
          for (let p = 0; p < this.labourForList.length; p++) {
            if (this.labourForList[p].text.toLowerCase() === labourDemand.toLowerCase()) {
              labourDemand = String(this.labourForList[p].id);
              LabourDemandForFound = true;
              break;
            }
          }
        }
        if (!LabourDemandForFound) {
          labourDemand = "";
        }

        let validityPeriod = (element["Validity Period"] || "").toString().trim();
        if (validityPeriod !== "") {
          const validityPeriodFound = this.validityPeriodList.find(
            (item) => item.text.toLowerCase() === validityPeriod.toLowerCase()
          );
          if (validityPeriodFound) {
            validityPeriod = validityPeriodFound.id;
          } else {
            validityPeriod = "";
          }
        }

        let workmanCategory = (element["Associate Category"] || "").toString().trim();
        if (workmanCategory !== "") {
          const workmanCategoryFound = this.workmanCategoryList.find(
            (item) => item.text.toLowerCase() === workmanCategory.toLowerCase()
          );
          if (workmanCategoryFound) {
            workmanCategory = workmanCategoryFound.id;
          } else {
            workmanCategory = "";
          }
        }

        const permanentPincode = (element["Permanent Pincode"] || "").toString().trim();
        let permanentVillageCode = null;
        if (permanentPincode !== "") {
          for (let p = 0; p < this.pincodeList.length; p++) {
            if (
              this.pincodeList[p].text.toLowerCase() === permanentPincode.toLowerCase()
            ) {
              permanentVillageCode = this.pincodeList[p].id;
              break;
            }
          }
        }

        const pincode = (element["Pincode"] || "").toString().trim();
        let villageCode = null;
        if (pincode !== "") {
          for (let p = 0; p < this.pincodeList.length; p++) {
            if (
              this.pincodeList[p].text.toLowerCase() === pincode.toLowerCase()
            ) {
              villageCode = this.pincodeList[p].id;
              break;
            }
          }
        }

        const plant = (element["Plant"] || "").toString().trim();
        const unit = (element["Unit"] || "").toString().trim();
        const department = (element["Department"] || "").toString().trim();
        const section1 = (element["Section"] || "").toString().trim();
        const section2 = (element["Sub-Section 1"] || "").toString().trim();
        const section3 = (element["Sub-Section 2"] || "").toString().trim();
        const licenseType = (element["Driving License Type"] || "").toString().trim();

        let drivingLicenseType = ''
        this.drivingLicenseType.forEach((_type: any) => {
          if (licenseType === _type.text) {
            drivingLicenseType = _type.id + '';
          }
        });

         let paymentType = ''
        this.bankPaymentTypes.forEach((_type: any) => {
          if (element["Payment Type"] === _type.text) {
            paymentType = _type.id + '';
          }
        });

        let plantCode = null;
        let unitCode = null;
        let departmentCode = null;
        let sectionPlantRelationId1 = null;
        let sectionPlantRelationId2 = null;
        let sectionPlantRelationId3 = null;

        const plantFound = this.plantUnitDepartmentTree.find(
          (item) => item.Plant0.toLowerCase() === plant.toLowerCase()
        );
        if (plantFound) {
          plantCode = plantFound.Plantcode0;

          const unitFound = plantFound.Values.find(
            (item) => item.Unit0.toLowerCase() === unit.toLowerCase()
          );
          if (unitFound) {
            unitCode = unitFound.Unitcode0;
            const departmentFound = unitFound.Values.find(
              (item) =>
                item.Department0.toLowerCase() === department.toLowerCase()
            );
            if (departmentFound) {
              departmentCode = departmentFound.Departmentcode0;

              const section1Found = departmentFound.Values.find(
                (item) =>
                  item.SectionName0.toLowerCase() === section1.toLowerCase()
              );
              if (section1Found) {
                sectionPlantRelationId1 = section1Found.Sectioncode0;

                const section2Found = section1Found.Values.find(
                  (item) =>
                    item.SectionName1.toLowerCase() === section2.toLowerCase()
                );
                if (section2Found) {
                  sectionPlantRelationId2 = section2Found.Sectioncode1;

                  const section3Found = section2Found.Values.find(
                    (item) =>
                      item.SectionName2.toLowerCase() === section3.toLowerCase()
                  );
                  if (section3Found) {
                    sectionPlantRelationId3 = section3Found.LevelID2;
                  }
                }
              }
            }
          }
        }

        let mobile = (element["Mobile"] || "").toString().trim();
        element["Mobile"] = (mobile.length === 10) ? mobile : "";

        let rMobile = (element["Referance Mobile"] || "").toString().trim();
        element["Referance Mobile"] = (rMobile.length === 10) ? rMobile : "";

        let eMobile = (element["Emergency Mobile"] || "").toString().trim();
        element["Emergency Mobile"] = (eMobile.length === 10) ? eMobile : "";

        importData.push({
          Login_UserId: GLOBAL.USER_ID,
          Plant_Code: plantCode,
          Unit_Code: unitCode,
          Department_Code: departmentCode,
          SectionPlantRelationId1: sectionPlantRelationId1,
          SectionPlantRelationId2: sectionPlantRelationId2,
          SectionPlantRelationId3: sectionPlantRelationId3,

          WageCriteria: (element["Wage Criteria"] || "").toString().trim(),
          LabourDemandFor: labourDemand,
          Nationality: nationality,
          WorkSite: workSite,
          WorkCategory: workCategory,

          ValidityPeriod: validityPeriod,
          WorkmanCategory: workmanCategory,

          FirstName: (element["First Name"] || "").toString().trim(),
          FatherHusbandName: (element["Father/Husband Name"] || "").toString().trim(),
          Relation: relation,
          LastName: (element["Last Name"] || "").toString().trim(),
          BirthDate: dob,
          Gender: gender,
          MaritalStatus: maritalStatus,
          PoliceVerificationDate: pvDate,
          PermanentAddress: (element["Permanent Address"] || "").toString().trim(),
          PermanentLandMark: (element["Permanent Land Mark"] || "").toString().trim(),
          PermanentArea: (element["Permanent Area"] || "").toString().trim(),
          PermanentPincode: (element["Permanent Pincode"] || "").toString().trim(),
          PermanentVillageCode: null,

          LocalAddress: (element["Local Address"] || "").toString().trim(),
          LocalLandMark: (element["Local Land Mark"] || "").toString().trim(),
          LocalArea: (element["Local Area"] || "").toString().trim(),
          Pincode: (element["Pincode"] || "").toString().trim(),
          VillageCode: null,

          Qualification: qualification,
          Q_SchoolCollege: (element['Q_School/College'] || '').toString().trim(),
          Q_YearofPassing: (element['Q_Year of Passing'] || '').toString().trim(),
          Q_ClassOrGrade: (element['Q_Class Or Grade'] || '').toString().trim(),
          Q_MediumofInstruction: (element['Q_Medium of Instruction'] || element['Q_Medium of Instruction '] || '').toString().trim(),
          Q_SpecializedCourse: (element['Q_Specialized Course'] || '').toString().trim(),
          Q_Percentage: (element['Q_Percentage'] || '').toString().trim(),
          QulificationStream: qulificationStream,
          QS_SchoolCollege: (element['QS_School/College'] || '').toString().trim(),
          QS_YearofPassing: (element['QS_Year of Passing'] || '').toString().trim(),
          QS_ClassOrGrade: (element['QS_Class Or Grade'] || '').toString().trim(),
          QS_MediumofInstruction: (element['QS_Medium of Instruction'] || element['QS_Medium of Instruction '] || '').toString().trim(),
          QS_SpecializedCourse: (element['QS_Specialized Course'] || '').toString().trim(),
          QS_Percentage: (element['QS_Percentage'] || '').toString().trim(),
          TechnicalQulification: technicalQulification,
          TQ_SchoolCollege: (element['TQ_School/College'] || '').toString().trim(),
          TQ_YearofPassing: (element['TQ_Year of Passing'] || '').toString().trim(),
          TQ_ClassOrGrade: (element['TQ_Class Or Grade'] || '').toString().trim(),
          TQ_MediumofInstruction: (element['TQ_Medium of Instruction'] || element['TQ_Medium of Instruction '] || '').toString().trim(),
          TQ_SpecializedCourse: (element['TQ_Specialized Course'] || '').toString().trim(),
          TQ_Percentage: (element['TQ_Percentage'] || '').toString().trim(),
          Cast: cast,
          Religion: religion,

          PANNo: (element["PAN No"] || "").toString().trim().toUpperCase(),
          NameInPAN: (element["NameIn PAN"] || "").toString().trim(),

          AdhaarCardNumber: (element["Adhaar Card Number"] || "").toString().trim(),
          NameInAdhaarCard: (element["Name In Adhaar Card"] || "").toString().trim(),
          VoterIDNumber: (element["Voter-IDNumber"] || "").toString().trim(),
          NameInVoterID: (element["Name In Voter-ID"] || "").toString().trim(),
          RationCardNumber: (element["Ration Card Number"] || "").toString().trim(),
          NameInRationCard: (element["Name In Ration Card"] || "").toString().trim(),
          DrivingLicenseType: drivingLicenseType,
          LicenseBatchNumber: (element["License Batch Number"] || "").toString().trim(),
          DrivingLicenseNumber: (element["Driving License Number"] || "").toString().trim(),
          NameInDrivingLicense: (element["Name In Driving License"] || "").toString().trim(),
          DrivingLicenseExpireDate: dled,
          NameInPassport: (element["Name In Passport"] || '').toString().trim(),
          PassportNumber: (element["Passport Number"] || "").toString().trim(),
          PassportRegistraionDate: prDate,
          PassportExpireDate: peDate,

          BankName: bankName,
          BranchCode: (element["Branch Code"] || "").toString().trim(),
          BankBranch: (element["Bank Branch"] || "").toString().trim(),
          AccountNumber: (element["Account Number"] || "").toString().trim(),
          IFSCCode: (element["IFSC Code"] || "").toString().trim(),
          NameAsPerBankRecord: (element["Name As Per Bank Record"] || "").toString().trim(),
          PaymentType: paymentType,

          BloodGroup: bloodGroup,
          SkillType: skill,
          Trade: trade,
          UANNumber: (element["UAN No"] || "").toString().trim(),
          DGMSNo: (element["DGMS No"] || "").toString().trim(),
          ESICNo: (element["ESIC No"] || "").toString().trim(),
          PFNo: (element["PF No"] || "").toString().trim(),
          Mobile: mobile,

          RFullName: (element["R-Full Name"] || "").toString().trim(),
          RRelation: rrelation,
          RAddress: (element["R-Address"] || "").toString().trim(),
          RLandMark: (element["R-Land Mark"] || "").toString().trim(),
          RArea: (element["R-Area"] || "").toString().trim(),
          RCountry: (element["R-Country"] || "").toString().trim(),
          RState: (element["R-State"] || "").toString().trim(),
          RDistrict: (element["R-District"] || "").toString().trim(),
          RCity: (element["R-City"] || "").toString().trim(),
          RPincode: (element["R-PinCode"] || "").toString().trim(),
          RMobile: rMobile,

          EFullName: (element["E-Full Name"] || "").toString().trim(),
          ERelation: erelation,
          EAddress: (element["E-Address"] || "").toString().trim(),
          ELandMark: (element["E-Land Mark"] || "").toString().trim(),
          EArea: (element["E-Area"] || "").toString().trim(),
          ECountry: (element["E-Country"] || "").toString().trim(),
          EState: (element["E-State"] || "").toString().trim(),
          EDistrict: (element["E-District"] || "").toString().trim(),
          ECity: (element["E-City"] || "").toString().trim(),
          EPincode: (element["E-PinCode"] || "").toString().trim(),
          EMobile: eMobile,
        });
      }
    }
    this.initializeForm();
    this.labourData = importData;
    this.totalExcelData = importData.length
    await this.validateDataByService();
    setTimeout(async () => {
     await this.importAndLoadDataFaster();
    await this.loadTableData();
    this.isUploadFile = true;
    this.fileInput.nativeElement.value = null;
    await this.startValidationInterval();
    }, 2000);
  }

  async importAndLoadDataFaster() {
    const tasks = this.labourData.map(async (result, index) => {
      await Promise.all([
        this.getDepartmentsByUnit(result.Unit_Code, index),
        this.getUnitsByPlant(result.Plant_Code, index),
        this.getSectionsByDepartment(result.Department_Code, index),
        this.getSectionsBySection1(result.SectionPlantRelationId1, index),
        this.getSectionsBySection2(result.SectionPlantRelationId2, index),
      ]);
    });

    await Promise.all(tasks);
  }

  fillAllRows(field: string, rowIndex: number) {
    const selectedValue = this.labourData[rowIndex][field];
    if (!selectedValue) {
      alert("Please select a value first!");
      return;
    }

    this.labourData = this.labourData.map((row, index) => {
      let isValid = false;

      switch (field) {
        case 'SectionPlantRelationId3':
          isValid = row['SectionPlantRelationId2'] === this.labourData[rowIndex]['SectionPlantRelationId2'];
          break;
        case 'SectionPlantRelationId2':
          isValid = row['SectionPlantRelationId1'] === this.labourData[rowIndex]['SectionPlantRelationId1'];
          break;
        case 'SectionPlantRelationId1':
          isValid = row['Department_Code'] === this.labourData[rowIndex]['Department_Code'];
          break;
        case 'Department_Code':
          isValid = row['Unit_Code'] === this.labourData[rowIndex]['Unit_Code'];
          break;
        case 'Unit_Code':
          isValid = row['Plant_Code'] === this.labourData[rowIndex]['Plant_Code'];
          break;
        default:
          isValid = !row[field] || row[field] === "";
          break;
      }

      if (isValid) {
        row[field] = selectedValue;
        const rowForm = this.rows.at(index);
        if (rowForm) {
          rowForm.patchValue({ [field]: selectedValue });
        }
      }

      return row;
    });
  }

  selectAllRows(field: string, rowIndex: number) {
    const selectedValue = this.labourData[rowIndex][field];
    if (!selectedValue) {
      alert("Please select a value first!");
      return;
    }

    this.labourData = this.labourData.map((row, index) => {
      let isValid = false;

      switch (field) {
        case 'SectionPlantRelationId3':
          isValid = row['SectionPlantRelationId2'] === this.labourData[rowIndex]['SectionPlantRelationId2'];
          break;
        case 'SectionPlantRelationId2':
          isValid = row['SectionPlantRelationId1'] === this.labourData[rowIndex]['SectionPlantRelationId1'];
          break;
        case 'SectionPlantRelationId1':
          isValid = row['Department_Code'] === this.labourData[rowIndex]['Department_Code'];
          break;
        case 'Department_Code':
          isValid = row['Unit_Code'] === this.labourData[rowIndex]['Unit_Code'];
          break;
        case 'Unit_Code':
          isValid = row['Plant_Code'] === this.labourData[rowIndex]['Plant_Code'];
          break;
        default:
          isValid = true;
          break;
      }

      if (isValid) {
        row[field] = selectedValue;
        const rowForm = this.rows.at(index);
        if (rowForm) {
          rowForm.patchValue({ [field]: selectedValue });
        }
      }

      return row;
    });
  }

  loadTableData() {
    const rowsArray = this.tableForm.get('rows') as FormArray;
    while (this.rows.length !== 0) {
      this.rows.removeAt(0);
    }
    this.labourData.forEach(labour => {
      rowsArray.push(this.createRow(labour));
    });
    this.isLoading = false;
    this.dataSet = false;
  }

  createRow(labour): FormGroup {
    let group = this.fb.group({});

    this.columnDefs.forEach(col => {
      const control = new FormControl(labour[col.field] || '');

      if (col.type === 'readonly') {
        control.disable();
      }

      group.addControl(col.field, control);
    });

    return group;
  }

  removeSortCharFromKeys(data) {
    const newData = [];
    data.forEach((obj) => {
      const newObj = Object.keys(obj).reduce(
        (result, key) => {
          const newKey = key.replace("↓", "").trim();
          result[newKey] = obj[key];
          return result;
        },
        Array.isArray(obj) ? [] : {}
      );
      newData.push(newObj);
    });

    return newData;
  }

  startValidationInterval() {
  this.isLoading = true;
  this.dataUpload = true;

  setTimeout(() => {

    for (let rowIndex = 0; rowIndex < this.labourData.length; rowIndex++) {
      const row = this.labourData[rowIndex];
      for (const field in row) {
        if (row.hasOwnProperty(field)) {
          this.validateRow(rowIndex, field, 6);
        }
      }
    }

    this.isLoading = false;
    this.dataUpload = false;

    // IMPORTANT: trigger UI update for OnPush
    this.cdr.markForCheck();

  }, 1000); // immediate async execution
}


 trackByRow(index: number, row: any) {
  return row && row.Id ? row.Id : index;
}

  getOptions(colField: string, rowIndex: number): any[] {
    const row = this.labourData[rowIndex];
    switch (colField) {
      case 'Unit_Code':
        return row.UnitList || [];

      case 'Department_Code':
        return row.DepartmentList || [];

      case 'SectionPlantRelationId1':
        return row.SectionList1 || [];

      case 'SectionPlantRelationId2':
        return row.SectionList2 || [];

      case 'SectionPlantRelationId3':
        return row.SectionList3 || [];

      case 'EVillageCode':
        if (row.EPincode && this.pincodeMap[row.EPincode]) {
          const villageList = this.pincodeMap[row.EPincode].VillageList || [];
          const defaultVillage = villageList.length > 0 ? villageList[0].id : null;
          const defaultState = villageList.length > 0 ? villageList[0].State : null;
          const defaultDistrict = villageList.length > 0 ? villageList[0].District : null;
          const defaultCity = villageList.length > 0 ? villageList[0].City : null;
          const rowForm = this.rows.at(rowIndex);
          if (rowForm && (!rowForm.get('EVillageCode').value || rowForm.get('EVillageCode').value === '')) {
            rowForm.patchValue({ EVillageCode: defaultVillage || 0 });
            rowForm.patchValue({ EState: defaultState || 0 });
            rowForm.patchValue({ EDistct: defaultDistrict || 0 });
            rowForm.patchValue({ ECity: defaultCity || 0 });

          }
          return villageList;
        }
        return [];

      case 'PermanentVillageCode':
        if (row.PermanentPincode && this.pincodeMap[row.PermanentPincode]) {
          const villageList = this.pincodeMap[row.PermanentPincode].VillageList || [];
          const defaultVillage = villageList.length > 0 ? villageList[0].id : null;
          const defaultState = villageList.length > 0 ? villageList[0].State : null;
          const defaultDistrict = villageList.length > 0 ? villageList[0].District : null;
          const defaultCity = villageList.length > 0 ? villageList[0].City : null;
          const rowForm = this.rows.at(rowIndex);
          if (rowForm && (!rowForm.get('PermanentVillageCode').value || rowForm.get('PermanentVillageCode').value === '')) {
            rowForm.patchValue({ PermanentVillageCode: defaultVillage || 0 });
            rowForm.patchValue({ PermanentState: defaultState || 0 });
            rowForm.patchValue({ PermanentDistct: defaultDistrict || 0 });
            rowForm.patchValue({ PermanentCity: defaultCity || 0 });
          }
          return villageList;
        }
        return [];

      case 'VillageCode':
        if (row.Pincode && this.pincodeMap[row.Pincode]) {
          const villageList = this.pincodeMap[row.Pincode].VillageList || [];
          const defaultVillage = villageList.length > 0 ? villageList[0].id : null;
          const defaultState = villageList.length > 0 ? villageList[0].State : null;
          const defaultDistrict = villageList.length > 0 ? villageList[0].District : null;
          const defaultCity = villageList.length > 0 ? villageList[0].City : null;
          const rowForm = this.rows.at(rowIndex);
          if (rowForm && (!rowForm.get('VillageCode').value || rowForm.get('VillageCode').value === '')) {
            rowForm.patchValue({ VillageCode: defaultVillage || 0 });
            rowForm.patchValue({ State: defaultState || 0 });
            rowForm.patchValue({ Distct: defaultDistrict || 0 });
            rowForm.patchValue({ City: defaultCity || 0 });
          }
          return villageList;
        }
        return [];

      case 'RVillageCode':
        if (row.RPincode && this.pincodeMap[row.RPincode]) {
          const villageList = this.pincodeMap[row.RPincode].VillageList || [];
          const defaultVillage = villageList.length > 0 ? villageList[0].id : null;
          const defaultState = villageList.length > 0 ? villageList[0].State : null;
          const defaultDistrict = villageList.length > 0 ? villageList[0].District : null;
          const defaultCity = villageList.length > 0 ? villageList[0].City : null;
          const rowForm = this.rows.at(rowIndex);
          if (rowForm && (!rowForm.get('RVillageCode').value || rowForm.get('RVillageCode').value === '')) {
            rowForm.patchValue({ RVillageCode: defaultVillage || 0 });
            rowForm.patchValue({ RState: defaultState || 0 });
            rowForm.patchValue({ RDistct: defaultDistrict || 0 });
            rowForm.patchValue({ RCity: defaultCity || 0 });
          }
          return villageList;
        }
        return [];
      default:
        const colDef = this.columnDefs.find(col => col.field === colField);
        return colDef.options || [];
    }
  }


  async validateDataByService() {
    const pincodeSet = new Set();
    this.labourData.forEach((item) => {
      if (item.Pincode) {
        pincodeSet.add(item.Pincode);
      }
      if (item.PermanentPincode) {
        pincodeSet.add(item.PermanentPincode);
      }
      if (item.RPincode) {
        pincodeSet.add(item.RPincode);
      }
      if (item.EPincode) {
        pincodeSet.add(item.EPincode);
      }
    });

    const uniquePincodes = Array.from(pincodeSet);
    if (uniquePincodes.length > 0) {
     await this.getPincodeDetails(uniquePincodes, null, null);
    }
  }

  async getPincodeDetails(pincodeList, rowIndex, fieldName) {
    if (!pincodeList || pincodeList.length === 0) return;
    let newPincodeList = pincodeList.filter((item) => !this.pincodeMap[item] && !this.pincodeNotFoundSet.has(item));
    if (newPincodeList.length === 0) {
      pincodeList.forEach(pincode => {
        const location = this.pincodeMap[pincode];
        if (location) {
          this.updateVillageListForRow(pincode, rowIndex, fieldName, location);
        }
      });

      this.validateRow(rowIndex, fieldName, 7);
      return;
    }

   await this.labourService.getPincodeDetails(newPincodeList.join(',')).subscribe((res) => {
      if (res.length) {
        const groupedByZip = {};
        res.forEach((item) => {
          if (item.ZipCode) {
            if (!groupedByZip[item.ZipCode]) {
              groupedByZip[item.ZipCode] = {
                ...item,
                VillageList: []
              };
            }
            groupedByZip[item.ZipCode].VillageList.push({
              id: item.Village_Code,
              text: item.VillageName,
              State: item.State_Name,
              City: item.City_Name,
              District: item.District_Name,
            });
          }
        });

        Object.keys(groupedByZip).forEach(zip => {
          const location = groupedByZip[zip];
          this.pincodeMap[zip] = location;

          this.labourData.forEach(labour => {
            if (labour.Pincode == zip) {
              this.updateVillageListForRow(zip, rowIndex, "Pincode", location);
            }
            if (labour.PermanentPincode == zip) {
              this.updateVillageListForRow(zip, rowIndex, "Permanent", location);
            }
            if (labour.RPincode == zip) {
              this.updateVillageListForRow(zip, rowIndex, "R", location);
            }
            if (labour.EPincode == zip) {
              this.updateVillageListForRow(zip, rowIndex, "E", location);
            }
          });
        });
      }
      newPincodeList.forEach((item) => {
        if (!this.pincodeMap[item]) {
          this.pincodeNotFoundSet.add(item);
        }
      });

      this.validateRow(rowIndex, fieldName, 8);
    });
  }
  updateVillageListForRow(pincode: string, rowIndex: number, fieldName: string, location: any) {
    if (!this.labourData[rowIndex]) return;
  
    const row = this.labourData[rowIndex];
    const rowForm = this.rows.at(rowIndex);
    if (!rowForm) return;
  
    const villageList = location.VillageList || [];
    const defaultVillage = villageList.length > 0 ? villageList[0].id : null;
  
    const villageFieldMap = {
      EPincode: "EVillageCode",
      Pincode: "VillageCode",
      PermanentPincode: "PermanentVillageCode",
      RPincode: "RVillageCode"
    };
  
    const villageField = villageFieldMap[fieldName];
    const currentPincode = row[fieldName];
  
    if (pincode === currentPincode && (!rowForm.get(villageField).value || rowForm.get(villageField).value === '')) {
      rowForm.patchValue({ [villageField]: defaultVillage || 0 });
    }
  }
  

  isCheckAllPincodeValidate: boolean = true
  patchPincodeData(labour, location, prefix, fieldName) {
    if (!labour || !location) { return; }

    labour[`${prefix}VillageCode`] = location.VillageName;
    labour[`${prefix}State`] = location.State_Name;
    labour[`${prefix}Distct`] = location.District_Name;
    labour[`${prefix}City`] = location.City_Name;
    labour[`${prefix}Pincode`] = location.ZipCode;

    const rowIndex = this.labourData.indexOf(labour);
    if (rowIndex !== -1) {
      const rowForm = this.rows.at(rowIndex);
      if (rowForm) {
        rowForm.patchValue({
          [`${prefix}VillageCode`]: location.VillageName,
          [`${prefix}State`]: location.State_Name,
          [`${prefix}Distct`]: location.District_Name,
          [`${prefix}City`]: location.City_Name,
          [`${prefix}Pincode`]: location.ZipCode,
        });
      }
    }
  }


  saveData() {
    this.isLoading = true
    this.dataUpload = true
    if (this.labourData.length > 0) {
      const valid = this.validateData();
      if (valid.isValid) {
        this.labourService.importDataLatest(this.getApiRequestDataForImportLabour()).subscribe(
          (response) => {
            this.onCloseAction();
            if (response['29BA8F92-E774-45D6-A07C-975827F49171']) {
              this.labourData = [];
              this.isLoading = false
              this.logHelperService.logSuccess({
                message: "Associate Data imported successfully",
              });
              this.dataShareService.shareData({ function: "labourDataImportExcel", type: "saveImportExcel", data: 'ok' });
              if (this.save) {
                this.save.emit();
              }
            } else {
              this.isLoading = false
              this.logHelperService.logError({
                message: "Error in importing data. Please try later.",
              });
            }
          },
          (err) => {
            alert("Error in importing data. Please try later.");
          }
        );
      } else {
        this.isLoading = false
        this.dataUpload = false
        if (valid.msg === "") {
          alert("Please correct data.");
        } else {
          alert(valid.msg);
        }
      }
    } else {
      this.isLoading = false
      this.logHelperService.logError({
        message: "Please Select File First",
      });
    }
  }

  validateData() {
    const returnObj = {
      isValid: true,
      rowIndex: -1,
      field: "",
      msg: "",
    };

    for (let i = 0; i < this.labourData.length; i++) {
      const keys = Object.keys(this.labourData[i]);
      for (let j = 0; j < keys.length; j++) {
        const validObj = this.validateRow(i, keys[j], 9);
        if (!validObj.isValid) {
          returnObj.isValid = false;
          returnObj.rowIndex = i;
          returnObj.field = keys[j];
          returnObj.msg = "";
          break;
        }
      }
      if (!returnObj.isValid) {
        break;
      }
      const validObj = this.isOneAdressProofAvailable(i);
      if (!validObj.isValid) {
        returnObj.isValid = false;
        returnObj.rowIndex = i;
        returnObj.field = "PANNo";
        returnObj.msg = validObj.msg;
        break;
      }
    }
    return returnObj;
  }

  isOneAdressProofAvailable = (rowIndex) => {
    const returnObj = {
      isValid: true,
      msg: "",
    };

    const nationality = this.labourData[rowIndex]["Nationality"];
    if (nationality == 569) {
      const passportNumber = this.labourData[rowIndex]["PassportNumber"] || "";
      const passportRegistraionDate = this.labourData[rowIndex]["PassportRegistraionDate"] || "";
      const passportExpireDate = this.labourData[rowIndex]["PassportExpireDate"] || "";
      if (passportNumber !== "" && passportRegistraionDate !== "" && passportExpireDate !== "") {
        return returnObj;
      }
      returnObj.isValid = false;
      returnObj.msg = "Passport details are required for foreign nationals.";
      return returnObj;
    }

    const panNo = this.labourData[rowIndex]["PANNo"] || "";
    const nameInPAN = this.labourData[rowIndex]["NameInPAN"] || "";
    if (panNo !== "" && nameInPAN !== "") {
      return returnObj;
    }

    const adhaarCardNumber = this.labourData[rowIndex]["AdhaarCardNumber"] || "";
    const nameInAdhaarCard = this.labourData[rowIndex]["NameInAdhaarCard"] || "";
    if (adhaarCardNumber !== "" && nameInAdhaarCard !== "") {
      return returnObj;
    }

    const voterIDNumber = this.labourData[rowIndex]["VoterIDNumber"] || "";
    const nameInVoterID = this.labourData[rowIndex]["NameInVoterID"] || "";
    if (voterIDNumber !== "" && nameInVoterID !== "") {
      return returnObj;
    }

    const rationCardNumber = this.labourData[rowIndex]["RationCardNumber"] || "";
    const nameInRationCard = this.labourData[rowIndex]["NameInRationCard"] || "";
    if (rationCardNumber !== "" && nameInRationCard !== "") {
      return returnObj;
    }

    const drivingLicenseNumber = this.labourData[rowIndex]["DrivingLicenseNumber"] || "";
    const nameInDrivingLicense = this.labourData[rowIndex]["NameInDrivingLicense"] || "";
    const drivingLicenseExpireDate =
      this.labourData[rowIndex]["DrivingLicenseExpireDate"] || "";
    if (
      drivingLicenseNumber !== "" &&
      nameInDrivingLicense !== "" &&
      drivingLicenseExpireDate !== ""
    ) {
      return returnObj;
    }

    const passportNumber = this.labourData[rowIndex]["PassportNumber"] || "";
    const passportRegistraionDate = this.labourData[rowIndex]["PassportRegistraionDate"] || "";
    const passportExpireDate = this.labourData[rowIndex]["PassportExpireDate"] || "";
    if (
      passportNumber !== "" &&
      passportRegistraionDate !== "" &&
      passportExpireDate !== ""
    ) {
      return returnObj;
    }
    returnObj.isValid = false;
    returnObj.msg = "Atleast one address proof detail is required.";
    return returnObj;
  };

  findUnitDeptID(selectedDepartment: any) {
    for (const plant of this.plantUnitDepartmentTree) {
      for (const unit of plant.Values) {
        for (const department of unit.Values) {
          if (department.Departmentcode0 == selectedDepartment) {
            return department.UnitDeptID0;
          }
        }
      }
    }
    return null;
  }

  getSectionPlantId(section3: number) {
    for (let plant of this.dataShareService.plantUnitDepartmentTreeArrayDataShareService) {
      for (let unit of plant.Values) {
        for (let department of unit.Values) {
          for (let section1 of department.Values) {
            for (let section2 of section1.Values) {
              for (let section3Obj of section2.Values) {
                if (section3Obj.Sectioncode2 == section3) {
                  return section3Obj.LevelID2;
                }
              }
            }
          }
        }
      }
    }
    return null;
  }

  loginContractorCode: any
  getApiRequestDataForImportLabour() {
    const key = "29BA8F92-E774-45D6-A07C-975827F49171";
    const payload = {
      [key]: this.labourData.map((row) => {
        return {
          Labour_Code: "(SELECT @Id)",
          Sys_Code: "(SELECT 'OFF-' + CONVERT( VARCHAR(50), @Id))",
          FirstName: row.FirstName,
          MiddleName: row.FatherHusbandName,
          LastName: row.LastName,
          RelationMasterList_Code: Number(this.getIdByNameForImportLabour('relationList', row.Relation)),
          DOB: moment(row.BirthDate).isValid() ? moment(row.BirthDate).format("YYYY-MM-DD") : '',
          GenderMasterList_Code: Number(row.Gender),
          MaritalStatusMasterList_Code: Number(row.MaritalStatus),
          NationalityMasterList_Code: Number(row.Nationality),
          MobileNumber: Number(row.Mobile.replace(/\s+/g, "")),
          BloodGroup: Number(row.BloodGroup),
          PFUANNo: Number(row.UANNumber),
          CastMasterList_Code: Number(row.Cast),
          ReligionMasterList_Code: Number(row.Religion),
          IsProfileComplited: 0,
          PaymentTypeMasterList_Code : row.PaymentType,
          IsPhysicallyChallenge: false,
          CreateBy: Number(GLOBAL.USER_ID),
          ModifiedBy: Number(GLOBAL.USER_ID),
          IsActive: 1,
          IsDelete: 0,
          IsSync: 0,
          "7E988C36-6E29-4789-A7A6-FFB677CA70A6": {
            ID: null,
            Sys_Code: null,
            ReferenceType: 582,
            Reference_Code: null,
            BankNameMasterItem_Code: Number(this.getIdByNameForImportLabour('bankNameList', row.BankName)),
            BranchName: row.BankBranch,
            AccountTypeMasterList_Code: 219,
            AccountNumber: Number(row.AccountNumber),
            NameInBank: row.NameAsPerBankRecord,
            IFSCCode: row.IFSCCode,
            BranchCode: row.BranchCode,
            CreateBy: Number(GLOBAL.USER_ID),
            ModifiedBy: Number(GLOBAL.USER_ID),
            IsActive: 1,
            IsDelete: 0,
            IsSync: 0
          },
          "7C40046B-58DF-48B8-A365-994F1A15365A": {
            GatePassRequest_Code: "(SELECT @Id)",
            Sys_Code: "(SELECT 'OFF-' + CONVERT( VARCHAR(50), @Id))",
            Labour_Code: null,
            ESICWageCriteria: Number(row.WageCriteria === 'Wage / Salary   <   21000.00/- (ESIC Applicable)'), // 0: Wage ≥ 21000.00/- (EC Policy Applicable) | 1: Wage < 21000.00/-   (ESIC Applicable) // ?????
            Contractor_Code: this.loginContractorCode,
            PoliceVerificationDate: moment(row.PoliceVerificationDate).format("YYYY-MM-DDTHH:mm:ss"),
            PoliceValidityDate: moment(row.PoliceVerificationDate).isValid() ? moment(row.PoliceVerificationDate).add(6, 'months').format("YYYY-MM-DDTHH:mm:ss") : null,
            Plant_Code: row.Plant_Code,
            Skill_Code: Number(row.SkillType),
            Trade_Code: Number(row.Trade),
            PFNo: Number(row.PFNo),
            PFUANNo: Number(row.UANNumber),
            LabourDemandTypeMasterItem_Code: Number(this.getIdByNameForImportLabour('labourForList', row.LabourDemandFor)),
            ESICNo: Number(row.ESICNo),
            DGMCMinesCode: Number(row.DGMSNo),
            UnitRelationId: this.findUnitDeptID(row.Department_Code),
            SectionPlant_ID: this.getSectionPlantId(row.SectionPlantRelationId3),
            WorkCategoryMIT_Code: Number(row.WorkCategory),
            CategoryMIL_Code: Number(row.WorkmanCategory),
            CreateBy: Number(GLOBAL.USER_ID),
            ModifiedBy: Number(GLOBAL.USER_ID),
            IsActive: 1,
            IsDelete: 0,
            IsSync: 0,
          },
          "BCE6B8B2-03F5-4ED5-804E-9BB8D7730D08": [
            {
              ID: "(SELECT @Id)",
              Sys_Code: "(SELECT 'OFF-' + CONVERT( VARCHAR(50), @Id))",
              GatePassRequest_Code: null,
              WorksiteMasterItemList_Code: Number(row.WorkSite),
              CreateBy: Number(GLOBAL.USER_ID),
              ModifiedBy: Number(GLOBAL.USER_ID),
              IsActive: 1,
              IsDelete: 0,
              IsSync: 0
            }
          ],
          "3CBA56A1-FE3A-4534-92C6-53E095C1B2F8": [
            {
              ID: "(SELECT @Id)",
              Sys_Code: "(SELECT 'OFF-' + CONVERT( VARCHAR(50), @Id))",
              GatePassRequest_Code: null,
              WorkSiteCategory_Code: Number(row.WorkCategory),
              CreateBy: Number(GLOBAL.USER_ID),
              ModifiedBy: Number(GLOBAL.USER_ID),
              IsActive: 1,
              IsDelete: 0,
              IsSync: 0
            }
          ],
          "32CA1100-7454-4A2E-A118-266936F6E6E9": {
            ID: "(SELECT @Id)",
            Sys_Code: "(SELECT 'OFF-' + CONVERT( VARCHAR(50), @Id))",
            Labour_Code: null,
            ContractorVendorMaster_Code: Number(row.VendorCode),
            CreateBy: Number(GLOBAL.USER_ID),
            ModifiedBy: Number(GLOBAL.USER_ID),
            IsActive: 1,
            IsDelete: 0,
            IsSync: 0
          },
          "4A86E19F-05DE-41B2-BDD4-84C4AF8DC77D": [
            {
              Address_Code: "(SELECT @Id)",
              Sys_Code: "(SELECT 'OFF-' + CONVERT( VARCHAR(50), @Id))",
              RefTypeMasterList_Code: 573,
              Reference_Code: null,
              AddressTypeMasterList_Code: 558,
              Address1: row.LocalAddress,
              Address2: row.PermanentLandMark,
              Address3: row.PermanentArea,
              Country_Code: Number((this.pincodeMap[row.Pincode] && this.pincodeMap[row.Pincode].Country_Code)) || null,
              State_Code: Number((this.pincodeMap[row.Pincode] && this.pincodeMap[row.Pincode].State_Code)) || null,
              District_Code: Number((this.pincodeMap[row.Pincode] && this.pincodeMap[row.Pincode].District_Code)) || null,
              City_Code: Number((this.pincodeMap[row.Pincode] && this.pincodeMap[row.Pincode].City_Code)) || null,
              PostOffice_Code: Number((this.pincodeMap[row.Pincode] && this.pincodeMap[row.Pincode].PostOffice_Code)) || null,
              Village_Code: Number((this.pincodeMap[row.Pincode] && this.pincodeMap[row.Pincode].Village_Code)) || null,
              ZipCode: Number(row.Pincode),
              CreateBy: Number(GLOBAL.USER_ID),
              ModifiedBy: Number(GLOBAL.USER_ID),
              IsActive: 1,
              IsDelete: 0,
              IsSync: 0
            },
            {
              Address_Code: "(SELECT @Id)",
              Sys_Code: "(SELECT 'OFF-' + CONVERT( VARCHAR(50), @Id))",
              RefTypeMasterList_Code: 573,
              Reference_Code: null,
              AddressTypeMasterList_Code: 559,
              Address1: row.PermanentAddress,
              Address2: row.LocalLandMark,
              Address3: row.LocalArea,
              Country_Code: Number((this.pincodeMap[row.PermanentPincode] && this.pincodeMap[row.PermanentPincode].Country_Code)) || null, // ?????
              State_Code: Number((this.pincodeMap[row.PermanentPincode] && this.pincodeMap[row.PermanentPincode].State_Code)) || null,
              District_Code: Number((this.pincodeMap[row.PermanentPincode] && this.pincodeMap[row.PermanentPincode].District_Code)) || null,
              City_Code: Number((this.pincodeMap[row.PermanentPincode] && this.pincodeMap[row.PermanentPincode].City_Code)) || null,
              PostOffice_Code: Number((this.pincodeMap[row.PermanentPincode] && this.pincodeMap[row.PermanentPincode].PostOffice_Code)) || null, //?????
              Village_Code: Number((this.pincodeMap[row.PermanentPincode] && this.pincodeMap[row.PermanentPincode].Village_Code)) || null,
              ZipCode: row.PermanentPincode,
              CreateBy: GLOBAL.USER_ID,
              ModifiedBy: GLOBAL.USER_ID,
              IsActive: 1,
              IsDelete: 0,
              IsSync: 0
            }
          ],
          "005217B4-D297-4D09-A0BB-4C32798612C7": this.checkIdentityExist(row),
          "9C4B9CA0-FA86-40D8-9E84-2175867D00D7": [
            {
              ID: "(SELECT @Id)",
              Sys_Code: "(SELECT 'OFF-' + CONVERT( VARCHAR(50), @Id))",
              Labour_Code: null,
              ContactTypeMasterItem_Code: 562,
              FullName: row.RFullName,
              Relation: this.getIdByNameForImportLabour('relationList', row.RRelation),
              Address1: row.RAddress,
              Address2: row.RLandMark,
              Address3: row.RArea,
              Country_Code: Number((this.pincodeMap[row.RPincode] && this.pincodeMap[row.RPincode].Country_Code)) || null,
              State_Code: Number((this.pincodeMap[row.RPincode] && this.pincodeMap[row.RPincode].State_Code)) || null,
              District_Code: Number((this.pincodeMap[row.RPincode] && this.pincodeMap[row.RPincode].District_Code)) || null,
              City_Code: Number((this.pincodeMap[row.RPincode] && this.pincodeMap[row.RPincode].City_Code)) || null,
              PostOffice_Code: Number((this.pincodeMap[row.RPincode] && this.pincodeMap[row.RPincode].PostOffice_Code)) || null,
              Village_Code: Number((this.pincodeMap[row.RPincode] && this.pincodeMap[row.RPincode].Village_Code)) || null,
              ZipCode: Number(row.RPincode),
              IdentityTypeMasterItem_Code: 100,
              IdentityNumber: "Rakesh Patel",
              Mobile: row.RMobile,
              CreateBy: Number(GLOBAL.USER_ID),
              ModifiedBy: Number(GLOBAL.USER_ID),
              IsActive: 1,
              IsDelete: 0,
              IsSync: 0
            },
            {
              ID: "(SELECT @Id)",
              Sys_Code: "(SELECT 'OFF-' + CONVERT( VARCHAR(50), @Id))",
              Labour_Code: null,
              ContactTypeMasterItem_Code: 561,
              FullName: row.EFullName,
              Relation: this.getIdByNameForImportLabour('relationList', row.ERelation),
              Address1: row.EAddress,
              Address2: row.ELandMark,
              Address3: row.EArea,
              Country_Code: Number((this.pincodeMap[row.EPincode] && this.pincodeMap[row.EPincode].Country_Code)) || null, // find from contry apii --mg
              State_Code: Number((this.pincodeMap[row.EPincode] && this.pincodeMap[row.EPincode].State_Code)) || null,
              District_Code: Number((this.pincodeMap[row.EPincode] && this.pincodeMap[row.EPincode].District_Code)) || null,
              City_Code: Number((this.pincodeMap[row.EPincode] && this.pincodeMap[row.EPincode].City_Code)) || null,
              PostOffice_Code: Number((this.pincodeMap[row.EPincode] && this.pincodeMap[row.EPincode].PostOffice_Code)) || null, // find from contry apii --mg
              Village_Code: Number((this.pincodeMap[row.EPincode] && this.pincodeMap[row.EPincode].Village_Code)) || null,
              ZipCode: Number(row.EPincode),
              IdentityTypeMasterItem_Code: 100, // ?
              IdentityNumber: "Rakesh Patel",
              Mobile: row.EMobile,
              CreateBy: Number(GLOBAL.USER_ID),
              ModifiedBy: Number(GLOBAL.USER_ID),
              IsActive: 1,
              IsDelete: 0,
              IsSync: 0
            },
          ],
          "A79CFE1F-517D-42D6-B848-359E015AE1EF": [
            {
              ID: "(SELECT @Id)",
              Sys_Code: "(SELECT 'OFF-' + CONVERT( VARCHAR(50), @Id))",
              Labour_Code: null,
              EducationTypeMLT_Code: Number(row.Qualification),
              SchoolCollege: row.Q_SchoolCollege,
              PasssingYear: Number(row.Q_YearofPassing),
              ClassGrade: row.Q_ClassOrGrade,
              Medium: row.Q_MediumofInstruction,
              TechnicalCourse: row.Q_SpecializedCourse,
              Percentage: Number(row.Q_Percentage),
              CreateBy: Number(GLOBAL.USER_ID),
              ModifiedBy: Number(GLOBAL.USER_ID),
              IsActive: 1,
              IsDelete: 0,
              IsSync: 0
            },
            {
              ID: "(SELECT @Id)",
              Sys_Code: "(SELECT 'OFF-' + CONVERT( VARCHAR(50), @Id))",
              Labour_Code: null,
              EducationTypeMLT_Code: Number(row.QulificationStream),
              SchoolCollege: row.QS_SchoolCollege,
              PasssingYear: Number(row.QS_YearofPassing),
              ClassGrade: row.QS_ClassOrGrade,
              Medium: row.QS_MediumofInstruction,
              TechnicalCourse: row.QS_SpecializedCourse,
              Percentage: Number(row.QS_Percentage),
              CreateBy: Number(GLOBAL.USER_ID),
              ModifiedBy: Number(GLOBAL.USER_ID),
              IsActive: 1,
              IsDelete: 0,
              IsSync: 0
            },
            {
              ID: "(SELECT @Id)",
              Sys_Code: "(SELECT 'OFF-' + CONVERT( VARCHAR(50), @Id))",
              Labour_Code: null,
              EducationTypeMLT_Code: Number(row.TechnicalQulification),
              SchoolCollege: row.TQ_SchoolCollege,
              PasssingYear: Number(row.TQ_YearofPassing),
              ClassGrade: row.TQ_ClassOrGrade,
              Medium: row.TQ_MediumofInstruction,
              TechnicalCourse: row.TQ_SpecializedCourse,
              Percentage: Number(row.TQ_Percentage),
              CreateBy: Number(GLOBAL.USER_ID),
              ModifiedBy: Number(GLOBAL.USER_ID),
              IsActive: 1,
              IsDelete: 0,
              IsSync: 0
            }
          ]
        }
      })
    }
    return payload
  }

  getConractor() {
    this.labourService.getContractors().subscribe((response: any[]) => {
      this.loginContractorCode = response[0].ContractorVendor_Code
    });
  }

  getIdByNameForImportLabour = (listName: string, name: string) => {
    if (name && !isNaN(+name)) return name;
    if (name === "undefined") return '';
    const idetifiedObjArr = _.get(this, listName).filter(({ text }) => (text || '').toLowerCase().trim() === name.toLowerCase().trim()) || [];
    return idetifiedObjArr.length ? idetifiedObjArr[0].id : null
  }

  checkIdentityExist = (row) => {
    const identityExist = {
      "005217B4-D297-4D09-A0BB-4C32798612C7": []
    }

    row.PANNo && identityExist['005217B4-D297-4D09-A0BB-4C32798612C7'].push({
      ID: "(SELECT @Id)",
      Sys_Code: null,
      ReferencePersonType: 582,
      Reference_Code: null,
      TypeOfIdentityMasterItem_Code: 576, // 576 : PAN | 577 : Aadhar Card | 578 : Voter ID | 579 : Ration Card | 580 : Passport | 638 : NPR
      IdentiyNo: row.PANNo,
      // Otherno: null,
      NameInIdentity: row.NameInPAN,
      // RegistrationDate: null, //yyyy-mm-ddThh:mm:ss
      //ExpireDate: null, //yyyy-mm-ddThh:mm:ss
      // RenualDate: null, //yyyy-mm-ddThh:mm:ss
      CreatedDate: "(SELECT GetDate())",
      ModifiedDate: "(SELECT GetDate())",
      CreateBy: GLOBAL.USER_ID,
      ModifiedBy: GLOBAL.USER_ID,
      IsActive: 1,
      IsDelete: 0,
      IsSync: 0
    })

    row.AdhaarCardNumber && identityExist['005217B4-D297-4D09-A0BB-4C32798612C7'].push({
      ID: "(SELECT @Id)",
      Sys_Code: null,
      ReferencePersonType: 582,
      Reference_Code: null,
      TypeOfIdentityMasterItem_Code: 577, // 576 : PAN | 577 : Aadhar Card | 578 : Voter ID | 579 : Ration Card | 580 : Passport | 638 : NPR
      IdentiyNo: row.AdhaarCardNumber,
      // Otherno: null,
      NameInIdentity: row.NameInAdhaarCard,
      // RegistrationDate: null, //yyyy-mm-ddThh:mm:ss
      // ExpireDate: null, //yyyy-mm-ddThh:mm:ss
      // RenualDate: null, //yyyy-mm-ddThh:mm:ss
      CreatedDate: "(SELECT GetDate())",
      ModifiedDate: "(SELECT GetDate())",
      CreateBy: GLOBAL.USER_ID,
      ModifiedBy: GLOBAL.USER_ID,
      IsActive: 1,
      IsDelete: 0,
      IsSync: 0
    })

    row.VoterIDNumber && identityExist['005217B4-D297-4D09-A0BB-4C32798612C7'].push({
      ID: "(SELECT @Id)",
      Sys_Code: null,
      ReferencePersonType: 582,
      Reference_Code: null,
      TypeOfIdentityMasterItem_Code: 578, // 576 : PAN | 577 : Aadhar Card | 578 : Voter ID | 579 : Ration Card | 580 : Passport | 638 : NPR
      IdentiyNo: row.VoterIDNumber,
      // Otherno: null,
      NameInIdentity: row.NameInVoterID,
      // RegistrationDate: null, //yyyy-mm-ddThh:mm:ss
      // ExpireDate: null, //yyyy-mm-ddThh:mm:ss
      // RenualDate: null, //yyyy-mm-ddThh:mm:ss
      CreatedDate: "(SELECT GetDate())",
      ModifiedDate: "(SELECT GetDate())",
      CreateBy: GLOBAL.USER_ID,
      ModifiedBy: GLOBAL.USER_ID,
      IsActive: 1,
      IsDelete: 0,
      IsSync: 0
    })

    row.RationCardNumber && identityExist['005217B4-D297-4D09-A0BB-4C32798612C7'].push({
      ID: "(SELECT @Id)",
      Sys_Code: null,
      ReferencePersonType: 582,
      Reference_Code: null,
      TypeOfIdentityMasterItem_Code: 579, // 576 : PAN | 577 : Aadhar Card | 578 : Voter ID | 579 : Ration Card | 580 : Passport | 638 : NPR
      IdentiyNo: row.RationCardNumber,
      // Otherno: null,
      NameInIdentity: row.NameInRationCard,
      // RegistrationDate: null, //yyyy-mm-ddThh:mm:ss
      // ExpireDate: null, //yyyy-mm-ddThh:mm:ss
      // RenualDate: null, //yyyy-mm-ddThh:mm:ss
      CreatedDate: "(SELECT GetDate())",
      ModifiedDate: "(SELECT GetDate())",
      CreateBy: GLOBAL.USER_ID,
      ModifiedBy: GLOBAL.USER_ID,
      IsActive: 1,
      IsDelete: 0,
      IsSync: 0
    })

    row.PassportNumber && identityExist['005217B4-D297-4D09-A0BB-4C32798612C7'].push({
      ID: "(SELECT @Id)",
      Sys_Code: null,
      ReferencePersonType: 582,
      Reference_Code: null,
      TypeOfIdentityMasterItem_Code: 580, // 576 : PAN | 577 : Aadhar Card | 578 : Voter ID | 579 : Ration Card | 580 : Passport | 638 : NPR
      IdentiyNo: row.PassportNumber,
      NameInIdentity: row.NameInPassport, // ??????? add name for passport in exacle and grid --mg
      RegistrationDate: row.PassportRegistraionDate, //yyyy-mm-ddThh:mm:ss
      ExpireDate: row.PassportExpireDate, //yyyy-mm-ddThh:mm:ss
      CreatedDate: "(SELECT GetDate())",
      ModifiedDate: "(SELECT GetDate())",
      CreateBy: GLOBAL.USER_ID,
      ModifiedBy: GLOBAL.USER_ID,
      IsActive: 1,
      IsDelete: 0,
      IsSync: 0
    })

    row.DrivingLicenseNumber && identityExist['005217B4-D297-4D09-A0BB-4C32798612C7'].push({
      ID: "(SELECT @Id)",
      Sys_Code: null,
      ReferencePersonType: 582,
      Reference_Code: null,
      TypeOfIdentityMasterItem_Code: row.DrivingLicenseType, // 576 : PAN | 577 : Aadhar Card | 578 : Voter ID | 579 : Ration Card | 580 : Passport | 638 : NPR
      IdentiyNo: row.DrivingLicenseNumber,
      NameInIdentity: row.NameInDrivingLicense, // ??????? add name for driving license in exacle and grid --mg
      RegistrationDate: row.DrivingLicenseRegistraionDate, //yyyy-mm-ddThh:mm:ss
      ExpireDate: row.DrivingLicenseExpireDate, //yyyy-mm-ddThh:mm:ss
      CreatedDate: "(SELECT GetDate())",
      ModifiedDate: "(SELECT GetDate())",
      CreateBy: GLOBAL.USER_ID,
      ModifiedBy: GLOBAL.USER_ID,
      IsActive: 1,
      IsDelete: 0,
      IsSync: 0
    })

    return identityExist['005217B4-D297-4D09-A0BB-4C32798612C7']
  }

  onCloseAction(): void {
    this.isUploadFile = false
    if (this.closeModal) {
      this.closeModal.next();
    }
    this.activeModal.close();
  }
}
